import { jsx as b, jsxs as J, Fragment as st } from "react/jsx-runtime";
import { c as Mo, a as F } from "./helpers-A5nzBcJc.js";
import * as i from "react";
import be, { createContext as $t, use as on, useLayoutEffect as To, useState as Oo } from "react";
import * as ct from "react-dom";
import Io from "react-dom";
import { useFormContext as ko, FormProvider as Lo, Controller as _o } from "react-hook-form";
function an(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function In(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((o) => {
      const a = an(o, t);
      return !n && typeof a == "function" && (n = !0), a;
    });
    if (n)
      return () => {
        for (let o = 0; o < r.length; o++) {
          const a = r[o];
          typeof a == "function" ? a() : an(e[o], null);
        }
      };
  };
}
function j(...e) {
  return i.useCallback(In(...e), e);
}
// @__NO_SIDE_EFFECTS__
function We(e) {
  const t = /* @__PURE__ */ Do(e), n = i.forwardRef((r, o) => {
    const { children: a, ...c } = r, s = i.Children.toArray(a), u = s.find(Ho);
    if (u) {
      const l = u.props.children, f = s.map((m) => m === u ? i.Children.count(l) > 1 ? i.Children.only(null) : i.isValidElement(l) ? l.props.children : null : m);
      return /* @__PURE__ */ b(t, { ...c, ref: o, children: i.isValidElement(l) ? i.cloneElement(l, void 0, f) : null });
    }
    return /* @__PURE__ */ b(t, { ...c, ref: o, children: a });
  });
  return n.displayName = `${e}.Slot`, n;
}
var kn = /* @__PURE__ */ We("Slot");
// @__NO_SIDE_EFFECTS__
function Do(e) {
  const t = i.forwardRef((n, r) => {
    const { children: o, ...a } = n;
    if (i.isValidElement(o)) {
      const c = Bo(o), s = Vo(a, o.props);
      return o.type !== i.Fragment && (s.ref = r ? In(r, c) : c), i.cloneElement(o, s);
    }
    return i.Children.count(o) > 1 ? i.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var Fo = Symbol("radix.slottable");
function Ho(e) {
  return i.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === Fo;
}
function Vo(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], a = t[r];
    /^on[A-Z]/.test(r) ? o && a ? n[r] = (...s) => {
      const u = a(...s);
      return o(...s), u;
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...a } : r === "className" && (n[r] = [o, a].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function Bo(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
const sn = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, cn = Mo, lt = (e, t) => (n) => {
  var r;
  if ((t == null ? void 0 : t.variants) == null) return cn(e, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: o, defaultVariants: a } = t, c = Object.keys(o).map((l) => {
    const f = n == null ? void 0 : n[l], m = a == null ? void 0 : a[l];
    if (f === null) return null;
    const p = sn(f) || sn(m);
    return o[l][p];
  }), s = n && Object.entries(n).reduce((l, f) => {
    let [m, p] = f;
    return p === void 0 || (l[m] = p), l;
  }, {}), u = t == null || (r = t.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((l, f) => {
    let { class: m, className: p, ...h } = f;
    return Object.entries(h).every((w) => {
      let [d, g] = w;
      return Array.isArray(g) ? g.includes({
        ...a,
        ...s
      }[d]) : {
        ...a,
        ...s
      }[d] === g;
    }) ? [
      ...l,
      m,
      p
    ] : l;
  }, []);
  return cn(e, c, u, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
}, $o = lt(
  "ui-inline-flex ui-items-center ui-justify-center ui-whitespace-nowrap ui-rounded-lg ui-text-sm ui-font-semibold ui-ring-offset-background ui-transition-colors focus-visible:ui-outline-none focus-visible:ui-ring-2 focus-visible:ui-ring-ring focus-visible:ui-ring-offset-2 disabled:ui-pointer-events-none disabled:ui-cursor-not-allowed",
  {
    variants: {
      variant: {
        primary: "ui-btn-primary",
        secondary: "ui-btn-secondary",
        destructive: "ui-btn-destructive",
        outline: "ui-btn-primary-outline",
        ghost: "ui-btn-ghost",
        link: "ui-btn-link"
      },
      size: {
        sm: "ui-h-8 min-w-8 ui-px-3 py-1",
        md: "ui-h-10 min-w-10 ui-px-4 ui-py-2",
        lg: "ui-h-12 min-w-12 ui-px-4 ui-py-3",
        xl: "ui-h-14 min-w-14 ui-px-6 ui-py-4"
      }
    },
    defaultVariants: {
      variant: "primary",
      size: "lg"
    }
  }
), Wo = ({
  ref: e,
  className: t,
  variant: n,
  size: r,
  asChild: o = !1,
  ...a
}) => /* @__PURE__ */ b(
  o ? kn : "button",
  {
    className: F($o({ variant: n, size: r, className: t })),
    ref: e,
    ...a
  }
);
Wo.displayName = "Button";
const Zo = ({ ref: e, className: t, type: n, ...r }) => /* @__PURE__ */ b(
  "input",
  {
    type: n,
    className: F(
      "ui-flex ui-h-14 ui-w-full ui-rounded-md ui-border ui-border-input ui-bg-background ui-p-4 ui-text-sm ui-ring-offset-background file:ui-border-0 file:ui-bg-transparent file:ui-text-sm file:ui-font-medium placeholder:ui-text-muted-foreground focus-visible:ui-outline-none focus-visible:ui-ring-1 focus-visible:ui-ring-ring focus-visible:ui-ring-offset-1 disabled:ui-cursor-not-allowed disabled:ui-opacity-50",
      t
    ),
    ref: e,
    ...r
  }
);
Zo.displayName = "Input";
var Uo = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], Z = Uo.reduce((e, t) => {
  const n = /* @__PURE__ */ We(`Primitive.${t}`), r = i.forwardRef((o, a) => {
    const { asChild: c, ...s } = o, u = c ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ b(u, { ...s, ref: a });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {});
function zo(e, t) {
  e && ct.flushSync(() => e.dispatchEvent(t));
}
var jo = "Label", Ln = i.forwardRef((e, t) => /* @__PURE__ */ b(
  Z.label,
  {
    ...e,
    ref: t,
    onMouseDown: (n) => {
      var o;
      n.target.closest("button, input, select, textarea") || ((o = e.onMouseDown) == null || o.call(e, n), !n.defaultPrevented && n.detail > 1 && n.preventDefault());
    }
  }
));
Ln.displayName = jo;
var _n = Ln;
const Ko = lt(
  "ui-text-sm ui-font-medium ui-leading-none peer-disabled:ui-cursor-not-allowed peer-disabled:ui-opacity-70"
), Dn = ({
  ref: e,
  className: t,
  ...n
}) => /* @__PURE__ */ b(
  _n,
  {
    ref: e,
    className: F(Ko(), t),
    ...n
  }
);
Dn.displayName = _n.displayName;
const Fn = $t(
  {}
), Hn = $t(
  {}
), ut = () => {
  const e = on(Fn), t = on(Hn), { getFieldState: n, formState: r } = ko(), o = n(e.name, r);
  if (!e)
    throw new Error("useFormField should be used within <FormField>");
  const { id: a } = t;
  return {
    id: a,
    name: e.name,
    formItemId: `${a}-form-item`,
    formDescriptionId: `${a}-form-item-description`,
    formMessageId: `${a}-form-item-message`,
    ...o
  };
}, $c = Lo, Wc = ({
  ...e
}) => {
  const t = i.useMemo(() => ({ name: e.name }), [e.name]);
  return /* @__PURE__ */ b(Fn, { value: t, children: /* @__PURE__ */ b(_o, { ...e }) });
}, Yo = ({
  ref: e,
  className: t,
  ...n
}) => {
  const r = i.useId(), o = i.useMemo(() => ({ id: r }), [r]);
  return /* @__PURE__ */ b(Hn, { value: o, children: /* @__PURE__ */ b("div", { ref: e, className: F("ui-space-y-2", t), ...n }) });
};
Yo.displayName = "FormItem";
const Xo = ({
  ref: e,
  className: t,
  ...n
}) => {
  const { error: r, formItemId: o } = ut();
  return /* @__PURE__ */ b(
    Dn,
    {
      ref: e,
      className: F(r && "text-destructive", t),
      htmlFor: o,
      ...n
    }
  );
};
Xo.displayName = "FormLabel";
const qo = ({
  ref: e,
  ...t
}) => {
  const { error: n, formItemId: r, formDescriptionId: o, formMessageId: a } = ut();
  return /* @__PURE__ */ b(
    kn,
    {
      ref: e,
      id: r,
      "aria-describedby": n ? `${o} ${a}` : `${o}`,
      "aria-invalid": !!n,
      ...t
    }
  );
};
qo.displayName = "FormControl";
const Go = ({
  ref: e,
  className: t,
  ...n
}) => {
  const { formDescriptionId: r } = ut();
  return /* @__PURE__ */ b(
    "p",
    {
      ref: e,
      id: r,
      className: F("ui-text-sm ui-text-muted-foreground", t),
      ...n
    }
  );
};
Go.displayName = "FormDescription";
const Qo = ({
  ref: e,
  className: t,
  children: n,
  ...r
}) => {
  const { error: o, formMessageId: a } = ut(), c = o ? String(o == null ? void 0 : o.message) : n;
  return c ? /* @__PURE__ */ b(
    "p",
    {
      ref: e,
      id: a,
      className: F("ui-text-sm ui-font-medium ui-text-destructive", t),
      ...r,
      children: c
    }
  ) : null;
};
Qo.displayName = "FormMessage";
function dt(e, t = []) {
  let n = [];
  function r(a, c) {
    const s = i.createContext(c), u = n.length;
    n = [...n, c];
    const l = (m) => {
      var y;
      const { scope: p, children: h, ...w } = m, d = ((y = p == null ? void 0 : p[e]) == null ? void 0 : y[u]) || s, g = i.useMemo(() => w, Object.values(w));
      return /* @__PURE__ */ b(d.Provider, { value: g, children: h });
    };
    l.displayName = a + "Provider";
    function f(m, p) {
      var d;
      const h = ((d = p == null ? void 0 : p[e]) == null ? void 0 : d[u]) || s, w = i.useContext(h);
      if (w) return w;
      if (c !== void 0) return c;
      throw new Error(`\`${m}\` must be used within \`${a}\``);
    }
    return [l, f];
  }
  const o = () => {
    const a = n.map((c) => i.createContext(c));
    return function(s) {
      const u = (s == null ? void 0 : s[e]) || a;
      return i.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: u } }),
        [s, u]
      );
    };
  };
  return o.scopeName = e, [r, Jo(o, ...t)];
}
function Jo(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(a) {
      const c = r.reduce((s, { useScope: u, scopeName: l }) => {
        const m = u(a)[`__scope${l}`];
        return { ...s, ...m };
      }, {});
      return i.useMemo(() => ({ [`__scope${t.scopeName}`]: c }), [c]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function z(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
var Y = globalThis != null && globalThis.document ? i.useLayoutEffect : () => {
}, ei = i[" useInsertionEffect ".trim().toString()] || Y;
function Tt({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  },
  caller: r
}) {
  const [o, a, c] = ti({
    defaultProp: t,
    onChange: n
  }), s = e !== void 0, u = s ? e : o;
  {
    const f = i.useRef(e !== void 0);
    i.useEffect(() => {
      const m = f.current;
      m !== s && console.warn(
        `${r} is changing from ${m ? "controlled" : "uncontrolled"} to ${s ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), f.current = s;
    }, [s, r]);
  }
  const l = i.useCallback(
    (f) => {
      var m;
      if (s) {
        const p = ni(f) ? f(e) : f;
        p !== e && ((m = c.current) == null || m.call(c, p));
      } else
        a(f);
    },
    [s, e, a, c]
  );
  return [u, l];
}
function ti({
  defaultProp: e,
  onChange: t
}) {
  const [n, r] = i.useState(e), o = i.useRef(n), a = i.useRef(t);
  return ei(() => {
    a.current = t;
  }, [t]), i.useEffect(() => {
    var c;
    o.current !== n && ((c = a.current) == null || c.call(a, n), o.current = n);
  }, [n, o]), [n, r, a];
}
function ni(e) {
  return typeof e == "function";
}
function Vn(e) {
  const t = i.useRef({ value: e, previous: e });
  return i.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
function Bn(e) {
  const [t, n] = i.useState(void 0);
  return Y(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const a = o[0];
        let c, s;
        if ("borderBoxSize" in a) {
          const u = a.borderBoxSize, l = Array.isArray(u) ? u[0] : u;
          c = l.inlineSize, s = l.blockSize;
        } else
          c = e.offsetWidth, s = e.offsetHeight;
        n({ width: c, height: s });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
function ri(e, t) {
  return i.useReducer((n, r) => t[n][r] ?? n, e);
}
var $n = (e) => {
  const { present: t, children: n } = e, r = oi(t), o = typeof n == "function" ? n({ present: r.isPresent }) : i.Children.only(n), a = j(r.ref, ii(o));
  return typeof n == "function" || r.isPresent ? i.cloneElement(o, { ref: a }) : null;
};
$n.displayName = "Presence";
function oi(e) {
  const [t, n] = i.useState(), r = i.useRef(null), o = i.useRef(e), a = i.useRef("none"), c = e ? "mounted" : "unmounted", [s, u] = ri(c, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return i.useEffect(() => {
    const l = Ke(r.current);
    a.current = s === "mounted" ? l : "none";
  }, [s]), Y(() => {
    const l = r.current, f = o.current;
    if (f !== e) {
      const p = a.current, h = Ke(l);
      e ? u("MOUNT") : h === "none" || (l == null ? void 0 : l.display) === "none" ? u("UNMOUNT") : u(f && p !== h ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, u]), Y(() => {
    if (t) {
      let l;
      const f = t.ownerDocument.defaultView ?? window, m = (h) => {
        const d = Ke(r.current).includes(CSS.escape(h.animationName));
        if (h.target === t && d && (u("ANIMATION_END"), !o.current)) {
          const g = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", l = f.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = g);
          });
        }
      }, p = (h) => {
        h.target === t && (a.current = Ke(r.current));
      };
      return t.addEventListener("animationstart", p), t.addEventListener("animationcancel", m), t.addEventListener("animationend", m), () => {
        f.clearTimeout(l), t.removeEventListener("animationstart", p), t.removeEventListener("animationcancel", m), t.removeEventListener("animationend", m);
      };
    } else
      u("ANIMATION_END");
  }, [t, u]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: i.useCallback((l) => {
      r.current = l ? getComputedStyle(l) : null, n(l);
    }, [])
  };
}
function Ke(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function ii(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var ft = "Checkbox", [ai, Zc] = dt(ft), [si, Wt] = ai(ft);
function ci(e) {
  const {
    __scopeCheckbox: t,
    checked: n,
    children: r,
    defaultChecked: o,
    disabled: a,
    form: c,
    name: s,
    onCheckedChange: u,
    required: l,
    value: f = "on",
    // @ts-expect-error
    internal_do_not_use_render: m
  } = e, [p, h] = Tt({
    prop: n,
    defaultProp: o ?? !1,
    onChange: u,
    caller: ft
  }), [w, d] = i.useState(null), [g, y] = i.useState(null), v = i.useRef(!1), x = w ? !!c || !!w.closest("form") : (
    // We set this to true by default so that events bubble to forms without JS (SSR)
    !0
  ), S = {
    checked: p,
    disabled: a,
    setChecked: h,
    control: w,
    setControl: d,
    name: s,
    form: c,
    value: f,
    hasConsumerStoppedPropagationRef: v,
    required: l,
    defaultChecked: pe(o) ? !1 : o,
    isFormControl: x,
    bubbleInput: g,
    setBubbleInput: y
  };
  return /* @__PURE__ */ b(
    si,
    {
      scope: t,
      ...S,
      children: li(m) ? m(S) : r
    }
  );
}
var Wn = "CheckboxTrigger", Zn = i.forwardRef(
  ({ __scopeCheckbox: e, onKeyDown: t, onClick: n, ...r }, o) => {
    const {
      control: a,
      value: c,
      disabled: s,
      checked: u,
      required: l,
      setControl: f,
      setChecked: m,
      hasConsumerStoppedPropagationRef: p,
      isFormControl: h,
      bubbleInput: w
    } = Wt(Wn, e), d = j(o, f), g = i.useRef(u);
    return i.useEffect(() => {
      const y = a == null ? void 0 : a.form;
      if (y) {
        const v = () => m(g.current);
        return y.addEventListener("reset", v), () => y.removeEventListener("reset", v);
      }
    }, [a, m]), /* @__PURE__ */ b(
      Z.button,
      {
        type: "button",
        role: "checkbox",
        "aria-checked": pe(u) ? "mixed" : u,
        "aria-required": l,
        "data-state": Kn(u),
        "data-disabled": s ? "" : void 0,
        disabled: s,
        value: c,
        ...r,
        ref: d,
        onKeyDown: z(t, (y) => {
          y.key === "Enter" && y.preventDefault();
        }),
        onClick: z(n, (y) => {
          m((v) => pe(v) ? !0 : !v), w && h && (p.current = y.isPropagationStopped(), p.current || y.stopPropagation());
        })
      }
    );
  }
);
Zn.displayName = Wn;
var mt = i.forwardRef(
  (e, t) => {
    const {
      __scopeCheckbox: n,
      name: r,
      checked: o,
      defaultChecked: a,
      required: c,
      disabled: s,
      value: u,
      onCheckedChange: l,
      form: f,
      ...m
    } = e;
    return /* @__PURE__ */ b(
      ci,
      {
        __scopeCheckbox: n,
        checked: o,
        defaultChecked: a,
        disabled: s,
        required: c,
        onCheckedChange: l,
        name: r,
        form: f,
        value: u,
        internal_do_not_use_render: ({ isFormControl: p }) => /* @__PURE__ */ J(st, { children: [
          /* @__PURE__ */ b(
            Zn,
            {
              ...m,
              ref: t,
              __scopeCheckbox: n
            }
          ),
          p && /* @__PURE__ */ b(
            jn,
            {
              __scopeCheckbox: n
            }
          )
        ] })
      }
    );
  }
);
mt.displayName = ft;
var Un = "CheckboxIndicator", Zt = i.forwardRef(
  (e, t) => {
    const { __scopeCheckbox: n, forceMount: r, ...o } = e, a = Wt(Un, n);
    return /* @__PURE__ */ b(
      $n,
      {
        present: r || pe(a.checked) || a.checked === !0,
        children: /* @__PURE__ */ b(
          Z.span,
          {
            "data-state": Kn(a.checked),
            "data-disabled": a.disabled ? "" : void 0,
            ...o,
            ref: t,
            style: { pointerEvents: "none", ...e.style }
          }
        )
      }
    );
  }
);
Zt.displayName = Un;
var zn = "CheckboxBubbleInput", jn = i.forwardRef(
  ({ __scopeCheckbox: e, ...t }, n) => {
    const {
      control: r,
      hasConsumerStoppedPropagationRef: o,
      checked: a,
      defaultChecked: c,
      required: s,
      disabled: u,
      name: l,
      value: f,
      form: m,
      bubbleInput: p,
      setBubbleInput: h
    } = Wt(zn, e), w = j(n, h), d = Vn(a), g = Bn(r);
    i.useEffect(() => {
      const v = p;
      if (!v) return;
      const x = window.HTMLInputElement.prototype, E = Object.getOwnPropertyDescriptor(
        x,
        "checked"
      ).set, A = !o.current;
      if (d !== a && E) {
        const C = new Event("click", { bubbles: A });
        v.indeterminate = pe(a), E.call(v, pe(a) ? !1 : a), v.dispatchEvent(C);
      }
    }, [p, d, a, o]);
    const y = i.useRef(pe(a) ? !1 : a);
    return /* @__PURE__ */ b(
      Z.input,
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: c ?? y.current,
        required: s,
        disabled: u,
        name: l,
        value: f,
        form: m,
        ...t,
        tabIndex: -1,
        ref: w,
        style: {
          ...t.style,
          ...g,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0,
          // We transform because the input is absolutely positioned but we have
          // rendered it **after** the button. This pulls it back to sit on top
          // of the button.
          transform: "translateX(-100%)"
        }
      }
    );
  }
);
jn.displayName = zn;
function li(e) {
  return typeof e == "function";
}
function pe(e) {
  return e === "indeterminate";
}
function Kn(e) {
  return pe(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
const ui = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ i.createElement(i.Fragment, null, /* @__PURE__ */ i.createElement("path", { d: "M216.49,104.49l-80,80a12,12,0,0,1-17,0l-80-80a12,12,0,0,1,17-17L128,159l71.51-71.52a12,12,0,0,1,17,17Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ i.createElement(i.Fragment, null, /* @__PURE__ */ i.createElement("path", { d: "M208,96l-80,80L48,96Z", opacity: "0.2" }), /* @__PURE__ */ i.createElement("path", { d: "M215.39,92.94A8,8,0,0,0,208,88H48a8,8,0,0,0-5.66,13.66l80,80a8,8,0,0,0,11.32,0l80-80A8,8,0,0,0,215.39,92.94ZM128,164.69,67.31,104H188.69Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ i.createElement(i.Fragment, null, /* @__PURE__ */ i.createElement("path", { d: "M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,48,88H208a8,8,0,0,1,5.66,13.66Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ i.createElement(i.Fragment, null, /* @__PURE__ */ i.createElement("path", { d: "M212.24,100.24l-80,80a6,6,0,0,1-8.48,0l-80-80a6,6,0,0,1,8.48-8.48L128,167.51l75.76-75.75a6,6,0,0,1,8.48,8.48Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ i.createElement(i.Fragment, null, /* @__PURE__ */ i.createElement("path", { d: "M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,53.66,90.34L128,164.69l74.34-74.35a8,8,0,0,1,11.32,11.32Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ i.createElement(i.Fragment, null, /* @__PURE__ */ i.createElement("path", { d: "M210.83,98.83l-80,80a4,4,0,0,1-5.66,0l-80-80a4,4,0,0,1,5.66-5.66L128,170.34l77.17-77.17a4,4,0,1,1,5.66,5.66Z" }))
  ]
]), di = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ i.createElement(i.Fragment, null, /* @__PURE__ */ i.createElement("path", { d: "M216.49,168.49a12,12,0,0,1-17,0L128,97,56.49,168.49a12,12,0,0,1-17-17l80-80a12,12,0,0,1,17,0l80,80A12,12,0,0,1,216.49,168.49Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ i.createElement(i.Fragment, null, /* @__PURE__ */ i.createElement("path", { d: "M208,160H48l80-80Z", opacity: "0.2" }), /* @__PURE__ */ i.createElement("path", { d: "M213.66,154.34l-80-80a8,8,0,0,0-11.32,0l-80,80A8,8,0,0,0,48,168H208a8,8,0,0,0,5.66-13.66ZM67.31,152,128,91.31,188.69,152Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ i.createElement(i.Fragment, null, /* @__PURE__ */ i.createElement("path", { d: "M215.39,163.06A8,8,0,0,1,208,168H48a8,8,0,0,1-5.66-13.66l80-80a8,8,0,0,1,11.32,0l80,80A8,8,0,0,1,215.39,163.06Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ i.createElement(i.Fragment, null, /* @__PURE__ */ i.createElement("path", { d: "M212.24,164.24a6,6,0,0,1-8.48,0L128,88.49,52.24,164.24a6,6,0,0,1-8.48-8.48l80-80a6,6,0,0,1,8.48,0l80,80A6,6,0,0,1,212.24,164.24Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ i.createElement(i.Fragment, null, /* @__PURE__ */ i.createElement("path", { d: "M213.66,165.66a8,8,0,0,1-11.32,0L128,91.31,53.66,165.66a8,8,0,0,1-11.32-11.32l80-80a8,8,0,0,1,11.32,0l80,80A8,8,0,0,1,213.66,165.66Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ i.createElement(i.Fragment, null, /* @__PURE__ */ i.createElement("path", { d: "M210.83,162.83a4,4,0,0,1-5.66,0L128,85.66,50.83,162.83a4,4,0,0,1-5.66-5.66l80-80a4,4,0,0,1,5.66,0l80,80A4,4,0,0,1,210.83,162.83Z" }))
  ]
]), fi = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ i.createElement(i.Fragment, null, /* @__PURE__ */ i.createElement("path", { d: "M232.49,80.49l-128,128a12,12,0,0,1-17,0l-56-56a12,12,0,1,1,17-17L96,183,215.51,63.51a12,12,0,0,1,17,17Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ i.createElement(i.Fragment, null, /* @__PURE__ */ i.createElement(
      "path",
      {
        d: "M232,56V200a16,16,0,0,1-16,16H40a16,16,0,0,1-16-16V56A16,16,0,0,1,40,40H216A16,16,0,0,1,232,56Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ i.createElement("path", { d: "M205.66,85.66l-96,96a8,8,0,0,1-11.32,0l-40-40a8,8,0,0,1,11.32-11.32L104,164.69l90.34-90.35a8,8,0,0,1,11.32,11.32Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ i.createElement(i.Fragment, null, /* @__PURE__ */ i.createElement("path", { d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM205.66,85.66l-96,96a8,8,0,0,1-11.32,0l-40-40a8,8,0,0,1,11.32-11.32L104,164.69l90.34-90.35a8,8,0,0,1,11.32,11.32Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ i.createElement(i.Fragment, null, /* @__PURE__ */ i.createElement("path", { d: "M228.24,76.24l-128,128a6,6,0,0,1-8.48,0l-56-56a6,6,0,0,1,8.48-8.48L96,191.51,219.76,67.76a6,6,0,0,1,8.48,8.48Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ i.createElement(i.Fragment, null, /* @__PURE__ */ i.createElement("path", { d: "M229.66,77.66l-128,128a8,8,0,0,1-11.32,0l-56-56a8,8,0,0,1,11.32-11.32L96,188.69,218.34,66.34a8,8,0,0,1,11.32,11.32Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ i.createElement(i.Fragment, null, /* @__PURE__ */ i.createElement("path", { d: "M226.83,74.83l-128,128a4,4,0,0,1-5.66,0l-56-56a4,4,0,0,1,5.66-5.66L96,194.34,221.17,69.17a4,4,0,1,1,5.66,5.66Z" }))
  ]
]), mi = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ i.createElement(i.Fragment, null, /* @__PURE__ */ i.createElement("path", { d: "M79.51,144.49a12,12,0,1,1,17-17L112,143l47.51-47.52a12,12,0,0,1,17,17l-56,56a12,12,0,0,1-17,0ZM228,48V208a20,20,0,0,1-20,20H48a20,20,0,0,1-20-20V48A20,20,0,0,1,48,28H208A20,20,0,0,1,228,48Zm-24,4H52V204H204Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ i.createElement(i.Fragment, null, /* @__PURE__ */ i.createElement(
      "path",
      {
        d: "M216,48V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208A8,8,0,0,1,216,48Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ i.createElement("path", { d: "M173.66,98.34a8,8,0,0,1,0,11.32l-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35A8,8,0,0,1,173.66,98.34ZM224,48V208a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32H208A16,16,0,0,1,224,48ZM208,208V48H48V208H208Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ i.createElement(i.Fragment, null, /* @__PURE__ */ i.createElement("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm-34.34,77.66-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35a8,8,0,0,1,11.32,11.32Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ i.createElement(i.Fragment, null, /* @__PURE__ */ i.createElement("path", { d: "M172.24,99.76a6,6,0,0,1,0,8.48l-56,56a6,6,0,0,1-8.48,0l-24-24a6,6,0,0,1,8.48-8.48L112,151.51l51.76-51.75A6,6,0,0,1,172.24,99.76ZM222,48V208a14,14,0,0,1-14,14H48a14,14,0,0,1-14-14V48A14,14,0,0,1,48,34H208A14,14,0,0,1,222,48Zm-12,0a2,2,0,0,0-2-2H48a2,2,0,0,0-2,2V208a2,2,0,0,0,2,2H208a2,2,0,0,0,2-2Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ i.createElement(i.Fragment, null, /* @__PURE__ */ i.createElement("path", { d: "M173.66,98.34a8,8,0,0,1,0,11.32l-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35A8,8,0,0,1,173.66,98.34ZM224,48V208a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32H208A16,16,0,0,1,224,48ZM208,208V48H48V208H208Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ i.createElement(i.Fragment, null, /* @__PURE__ */ i.createElement("path", { d: "M170.83,101.17a4,4,0,0,1,0,5.66l-56,56a4,4,0,0,1-5.66,0l-24-24a4,4,0,0,1,5.66-5.66L112,154.34l53.17-53.17A4,4,0,0,1,170.83,101.17ZM220,48V208a12,12,0,0,1-12,12H48a12,12,0,0,1-12-12V48A12,12,0,0,1,48,36H208A12,12,0,0,1,220,48Zm-8,0a4,4,0,0,0-4-4H48a4,4,0,0,0-4,4V208a4,4,0,0,0,4,4H208a4,4,0,0,0,4-4Z" }))
  ]
]), pi = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ i.createElement(i.Fragment, null, /* @__PURE__ */ i.createElement("path", { d: "M208,28H48A20,20,0,0,0,28,48V208a20,20,0,0,0,20,20H208a20,20,0,0,0,20-20V48A20,20,0,0,0,208,28Zm-4,176H52V52H204ZM76,128a12,12,0,0,1,12-12h80a12,12,0,0,1,0,24H88A12,12,0,0,1,76,128Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ i.createElement(i.Fragment, null, /* @__PURE__ */ i.createElement(
      "path",
      {
        d: "M216,48V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208A8,8,0,0,1,216,48Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ i.createElement("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,176H48V48H208V208Zm-32-80a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h80A8,8,0,0,1,176,128Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ i.createElement(i.Fragment, null, /* @__PURE__ */ i.createElement("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM168,136H88a8,8,0,0,1,0-16h80a8,8,0,0,1,0,16Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ i.createElement(i.Fragment, null, /* @__PURE__ */ i.createElement("path", { d: "M208,34H48A14,14,0,0,0,34,48V208a14,14,0,0,0,14,14H208a14,14,0,0,0,14-14V48A14,14,0,0,0,208,34Zm2,174a2,2,0,0,1-2,2H48a2,2,0,0,1-2-2V48a2,2,0,0,1,2-2H208a2,2,0,0,1,2,2Zm-36-80a6,6,0,0,1-6,6H88a6,6,0,0,1,0-12h80A6,6,0,0,1,174,128Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ i.createElement(i.Fragment, null, /* @__PURE__ */ i.createElement("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,176H48V48H208V208Zm-32-80a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h80A8,8,0,0,1,176,128Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ i.createElement(i.Fragment, null, /* @__PURE__ */ i.createElement("path", { d: "M208,36H48A12,12,0,0,0,36,48V208a12,12,0,0,0,12,12H208a12,12,0,0,0,12-12V48A12,12,0,0,0,208,36Zm4,172a4,4,0,0,1-4,4H48a4,4,0,0,1-4-4V48a4,4,0,0,1,4-4H208a4,4,0,0,1,4,4Zm-40-80a4,4,0,0,1-4,4H88a4,4,0,0,1,0-8h80A4,4,0,0,1,172,128Z" }))
  ]
]), hi = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ i.createElement(i.Fragment, null, /* @__PURE__ */ i.createElement("path", { d: "M208,28H48A20,20,0,0,0,28,48V208a20,20,0,0,0,20,20H208a20,20,0,0,0,20-20V48A20,20,0,0,0,208,28Zm-4,176H52V52H204Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ i.createElement(i.Fragment, null, /* @__PURE__ */ i.createElement(
      "path",
      {
        d: "M216,48V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208A8,8,0,0,1,216,48Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ i.createElement("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,176H48V48H208V208Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ i.createElement(i.Fragment, null, /* @__PURE__ */ i.createElement("path", { d: "M224,48V208a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32H208A16,16,0,0,1,224,48Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ i.createElement(i.Fragment, null, /* @__PURE__ */ i.createElement("path", { d: "M208,34H48A14,14,0,0,0,34,48V208a14,14,0,0,0,14,14H208a14,14,0,0,0,14-14V48A14,14,0,0,0,208,34Zm2,174a2,2,0,0,1-2,2H48a2,2,0,0,1-2-2V48a2,2,0,0,1,2-2H208a2,2,0,0,1,2,2Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ i.createElement(i.Fragment, null, /* @__PURE__ */ i.createElement("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,176H48V48H208V208Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ i.createElement(i.Fragment, null, /* @__PURE__ */ i.createElement("path", { d: "M208,36H48A12,12,0,0,0,36,48V208a12,12,0,0,0,12,12H208a12,12,0,0,0,12-12V48A12,12,0,0,0,208,36Zm4,172a4,4,0,0,1-4,4H48a4,4,0,0,1-4-4V48a4,4,0,0,1,4-4H208a4,4,0,0,1,4,4Z" }))
  ]
]), gi = $t({
  color: "currentColor",
  size: "1em",
  weight: "regular",
  mirrored: !1
}), Ae = i.forwardRef(
  (e, t) => {
    const {
      alt: n,
      color: r,
      size: o,
      weight: a,
      mirrored: c,
      children: s,
      weights: u,
      ...l
    } = e, {
      color: f = "currentColor",
      size: m,
      weight: p = "regular",
      mirrored: h = !1,
      ...w
    } = i.useContext(gi);
    return /* @__PURE__ */ i.createElement(
      "svg",
      {
        ref: t,
        xmlns: "http://www.w3.org/2000/svg",
        width: o ?? m,
        height: o ?? m,
        fill: r ?? f,
        viewBox: "0 0 256 256",
        transform: c || h ? "scale(-1, 1)" : void 0,
        ...w,
        ...l
      },
      !!n && /* @__PURE__ */ i.createElement("title", null, n),
      s,
      u.get(a ?? p)
    );
  }
);
Ae.displayName = "IconBase";
const Yn = i.forwardRef((e, t) => /* @__PURE__ */ i.createElement(Ae, { ref: t, ...e, weights: ui }));
Yn.displayName = "CaretDownIcon";
const Xn = Yn, qn = i.forwardRef((e, t) => /* @__PURE__ */ i.createElement(Ae, { ref: t, ...e, weights: di }));
qn.displayName = "CaretUpIcon";
const vi = qn, Gn = i.forwardRef((e, t) => /* @__PURE__ */ i.createElement(Ae, { ref: t, ...e, weights: fi }));
Gn.displayName = "CheckIcon";
const Ut = Gn, Qn = i.forwardRef((e, t) => /* @__PURE__ */ i.createElement(Ae, { ref: t, ...e, weights: mi }));
Qn.displayName = "CheckSquareIcon";
const yi = Qn, Jn = i.forwardRef((e, t) => /* @__PURE__ */ i.createElement(Ae, { ref: t, ...e, weights: pi }));
Jn.displayName = "MinusSquareIcon";
const wi = Jn, er = i.forwardRef((e, t) => /* @__PURE__ */ i.createElement(Ae, { ref: t, ...e, weights: hi }));
er.displayName = "SquareIcon";
const bi = er, xi = ({
  ref: e,
  className: t,
  ...n
}) => /* @__PURE__ */ b(
  mt,
  {
    ref: e,
    className: F(
      "ui-peer ui-h-4 ui-w-4 ui-shrink-0 ui-border ui-border-primary ui-ring-offset-background focus-visible:ui-outline-none focus-visible:ui-ring-2 focus-visible:ui-ring-ring focus-visible:ui-ring-offset-2 disabled:ui-cursor-not-allowed disabled:ui-opacity-50 data-[state=checked]:ui-bg-blue-400 data-[state=checked]:ui-text-white",
      t
    ),
    ...n,
    children: /* @__PURE__ */ b(
      Zt,
      {
        className: F(
          "ui-flex ui-items-center ui-justify-center ui-text-current"
        ),
        children: /* @__PURE__ */ b(Ut, { size: 12, weight: "bold" })
      }
    )
  }
);
xi.displayName = mt.displayName;
const Si = ({
  className: e,
  ...t
}) => /* @__PURE__ */ J(
  mt,
  {
    ...t,
    className: F(
      "ui-peer ui-flex ui-justify-center ui-items-center",
      e
    ),
    children: [
      /* @__PURE__ */ J(
        Zt,
        {
          className: F(
            "ui-flex ui-items-center ui-justify-center ui-text-current"
          ),
          children: [
            t.checked === !0 && /* @__PURE__ */ b(
              yi,
              {
                size: 20,
                className: F("ui-text-blue-500"),
                weight: "fill",
                format: "outline"
              }
            ),
            t.checked === "indeterminate" && /* @__PURE__ */ b(
              wi,
              {
                size: 20,
                className: F("ui-text-blue-500"),
                weight: "fill",
                format: "stroke"
              }
            )
          ]
        }
      ),
      t.checked === !1 && /* @__PURE__ */ b(
        bi,
        {
          size: 20,
          format: "stroke",
          weight: "light",
          className: F("ui-text-primary")
        }
      )
    ]
  }
);
Si.displayName = "MultiStateCheckbox";
function ln(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
function Ei(e) {
  const t = e + "CollectionProvider", [n, r] = dt(t), [o, a] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), c = (d) => {
    const { scope: g, children: y } = d, v = be.useRef(null), x = be.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ b(o, { scope: g, itemMap: x, collectionRef: v, children: y });
  };
  c.displayName = t;
  const s = e + "CollectionSlot", u = /* @__PURE__ */ We(s), l = be.forwardRef(
    (d, g) => {
      const { scope: y, children: v } = d, x = a(s, y), S = j(g, x.collectionRef);
      return /* @__PURE__ */ b(u, { ref: S, children: v });
    }
  );
  l.displayName = s;
  const f = e + "CollectionItemSlot", m = "data-radix-collection-item", p = /* @__PURE__ */ We(f), h = be.forwardRef(
    (d, g) => {
      const { scope: y, children: v, ...x } = d, S = be.useRef(null), E = j(g, S), A = a(f, y);
      return be.useEffect(() => (A.itemMap.set(S, { ref: S, ...x }), () => void A.itemMap.delete(S))), /* @__PURE__ */ b(p, { [m]: "", ref: E, children: v });
    }
  );
  h.displayName = f;
  function w(d) {
    const g = a(e + "CollectionConsumer", d);
    return be.useCallback(() => {
      const v = g.collectionRef.current;
      if (!v) return [];
      const x = Array.from(v.querySelectorAll(`[${m}]`));
      return Array.from(g.itemMap.values()).sort(
        (A, C) => x.indexOf(A.ref.current) - x.indexOf(C.ref.current)
      );
    }, [g.collectionRef, g.itemMap]);
  }
  return [
    { Provider: c, Slot: l, ItemSlot: h },
    w,
    r
  ];
}
var Ci = i.createContext(void 0);
function Ai(e) {
  const t = i.useContext(Ci);
  return e || t || "ltr";
}
function xe(e) {
  const t = i.useRef(e);
  return i.useEffect(() => {
    t.current = e;
  }), i.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function Ri(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = xe(e);
  i.useEffect(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var Ni = "DismissableLayer", Ot = "dismissableLayer.update", Pi = "dismissableLayer.pointerDownOutside", Mi = "dismissableLayer.focusOutside", un, tr = i.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), nr = i.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: a,
      onInteractOutside: c,
      onDismiss: s,
      ...u
    } = e, l = i.useContext(tr), [f, m] = i.useState(null), p = (f == null ? void 0 : f.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, h] = i.useState({}), w = j(t, (C) => m(C)), d = Array.from(l.layers), [g] = [...l.layersWithOutsidePointerEventsDisabled].slice(-1), y = d.indexOf(g), v = f ? d.indexOf(f) : -1, x = l.layersWithOutsidePointerEventsDisabled.size > 0, S = v >= y, E = Ii((C) => {
      const P = C.target, k = [...l.branches].some((O) => O.contains(P));
      !S || k || (o == null || o(C), c == null || c(C), C.defaultPrevented || s == null || s());
    }, p), A = ki((C) => {
      const P = C.target;
      [...l.branches].some((O) => O.contains(P)) || (a == null || a(C), c == null || c(C), C.defaultPrevented || s == null || s());
    }, p);
    return Ri((C) => {
      v === l.layers.size - 1 && (r == null || r(C), !C.defaultPrevented && s && (C.preventDefault(), s()));
    }, p), i.useEffect(() => {
      if (f)
        return n && (l.layersWithOutsidePointerEventsDisabled.size === 0 && (un = p.body.style.pointerEvents, p.body.style.pointerEvents = "none"), l.layersWithOutsidePointerEventsDisabled.add(f)), l.layers.add(f), dn(), () => {
          n && l.layersWithOutsidePointerEventsDisabled.size === 1 && (p.body.style.pointerEvents = un);
        };
    }, [f, p, n, l]), i.useEffect(() => () => {
      f && (l.layers.delete(f), l.layersWithOutsidePointerEventsDisabled.delete(f), dn());
    }, [f, l]), i.useEffect(() => {
      const C = () => h({});
      return document.addEventListener(Ot, C), () => document.removeEventListener(Ot, C);
    }, []), /* @__PURE__ */ b(
      Z.div,
      {
        ...u,
        ref: w,
        style: {
          pointerEvents: x ? S ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: z(e.onFocusCapture, A.onFocusCapture),
        onBlurCapture: z(e.onBlurCapture, A.onBlurCapture),
        onPointerDownCapture: z(
          e.onPointerDownCapture,
          E.onPointerDownCapture
        )
      }
    );
  }
);
nr.displayName = Ni;
var Ti = "DismissableLayerBranch", Oi = i.forwardRef((e, t) => {
  const n = i.useContext(tr), r = i.useRef(null), o = j(t, r);
  return i.useEffect(() => {
    const a = r.current;
    if (a)
      return n.branches.add(a), () => {
        n.branches.delete(a);
      };
  }, [n.branches]), /* @__PURE__ */ b(Z.div, { ...e, ref: o });
});
Oi.displayName = Ti;
function Ii(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = xe(e), r = i.useRef(!1), o = i.useRef(() => {
  });
  return i.useEffect(() => {
    const a = (s) => {
      if (s.target && !r.current) {
        let u = function() {
          rr(
            Pi,
            n,
            l,
            { discrete: !0 }
          );
        };
        const l = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = u, t.addEventListener("click", o.current, { once: !0 })) : u();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, c = window.setTimeout(() => {
      t.addEventListener("pointerdown", a);
    }, 0);
    return () => {
      window.clearTimeout(c), t.removeEventListener("pointerdown", a), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function ki(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = xe(e), r = i.useRef(!1);
  return i.useEffect(() => {
    const o = (a) => {
      a.target && !r.current && rr(Mi, n, { originalEvent: a }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function dn() {
  const e = new CustomEvent(Ot);
  document.dispatchEvent(e);
}
function rr(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, a = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? zo(o, a) : o.dispatchEvent(a);
}
var xt = 0;
function Li() {
  i.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? fn()), document.body.insertAdjacentElement("beforeend", e[1] ?? fn()), xt++, () => {
      xt === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), xt--;
    };
  }, []);
}
function fn() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var St = "focusScope.autoFocusOnMount", Et = "focusScope.autoFocusOnUnmount", mn = { bubbles: !1, cancelable: !0 }, _i = "FocusScope", or = i.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: o,
    onUnmountAutoFocus: a,
    ...c
  } = e, [s, u] = i.useState(null), l = xe(o), f = xe(a), m = i.useRef(null), p = j(t, (d) => u(d)), h = i.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  i.useEffect(() => {
    if (r) {
      let d = function(x) {
        if (h.paused || !s) return;
        const S = x.target;
        s.contains(S) ? m.current = S : me(m.current, { select: !0 });
      }, g = function(x) {
        if (h.paused || !s) return;
        const S = x.relatedTarget;
        S !== null && (s.contains(S) || me(m.current, { select: !0 }));
      }, y = function(x) {
        if (document.activeElement === document.body)
          for (const E of x)
            E.removedNodes.length > 0 && me(s);
      };
      document.addEventListener("focusin", d), document.addEventListener("focusout", g);
      const v = new MutationObserver(y);
      return s && v.observe(s, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", d), document.removeEventListener("focusout", g), v.disconnect();
      };
    }
  }, [r, s, h.paused]), i.useEffect(() => {
    if (s) {
      hn.add(h);
      const d = document.activeElement;
      if (!s.contains(d)) {
        const y = new CustomEvent(St, mn);
        s.addEventListener(St, l), s.dispatchEvent(y), y.defaultPrevented || (Di($i(ir(s)), { select: !0 }), document.activeElement === d && me(s));
      }
      return () => {
        s.removeEventListener(St, l), setTimeout(() => {
          const y = new CustomEvent(Et, mn);
          s.addEventListener(Et, f), s.dispatchEvent(y), y.defaultPrevented || me(d ?? document.body, { select: !0 }), s.removeEventListener(Et, f), hn.remove(h);
        }, 0);
      };
    }
  }, [s, l, f, h]);
  const w = i.useCallback(
    (d) => {
      if (!n && !r || h.paused) return;
      const g = d.key === "Tab" && !d.altKey && !d.ctrlKey && !d.metaKey, y = document.activeElement;
      if (g && y) {
        const v = d.currentTarget, [x, S] = Fi(v);
        x && S ? !d.shiftKey && y === S ? (d.preventDefault(), n && me(x, { select: !0 })) : d.shiftKey && y === x && (d.preventDefault(), n && me(S, { select: !0 })) : y === v && d.preventDefault();
      }
    },
    [n, r, h.paused]
  );
  return /* @__PURE__ */ b(Z.div, { tabIndex: -1, ...c, ref: p, onKeyDown: w });
});
or.displayName = _i;
function Di(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (me(r, { select: t }), document.activeElement !== n) return;
}
function Fi(e) {
  const t = ir(e), n = pn(t, e), r = pn(t.reverse(), e);
  return [n, r];
}
function ir(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function pn(e, t) {
  for (const n of e)
    if (!Hi(n, { upTo: t })) return n;
}
function Hi(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function Vi(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function me(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && Vi(e) && t && e.select();
  }
}
var hn = Bi();
function Bi() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = gn(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = gn(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function gn(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function $i(e) {
  return e.filter((t) => t.tagName !== "A");
}
var Wi = i[" useId ".trim().toString()] || (() => {
}), Zi = 0;
function zt(e) {
  const [t, n] = i.useState(Wi());
  return Y(() => {
    n((r) => r ?? String(Zi++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
const Ui = ["top", "right", "bottom", "left"], he = Math.min, G = Math.max, nt = Math.round, Ye = Math.floor, ae = (e) => ({
  x: e,
  y: e
}), zi = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, ji = {
  start: "end",
  end: "start"
};
function It(e, t, n) {
  return G(e, he(t, n));
}
function ue(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function de(e) {
  return e.split("-")[0];
}
function ke(e) {
  return e.split("-")[1];
}
function jt(e) {
  return e === "x" ? "y" : "x";
}
function Kt(e) {
  return e === "y" ? "height" : "width";
}
const Ki = /* @__PURE__ */ new Set(["top", "bottom"]);
function ie(e) {
  return Ki.has(de(e)) ? "y" : "x";
}
function Yt(e) {
  return jt(ie(e));
}
function Yi(e, t, n) {
  n === void 0 && (n = !1);
  const r = ke(e), o = Yt(e), a = Kt(o);
  let c = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[a] > t.floating[a] && (c = rt(c)), [c, rt(c)];
}
function Xi(e) {
  const t = rt(e);
  return [kt(e), t, kt(t)];
}
function kt(e) {
  return e.replace(/start|end/g, (t) => ji[t]);
}
const vn = ["left", "right"], yn = ["right", "left"], qi = ["top", "bottom"], Gi = ["bottom", "top"];
function Qi(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? yn : vn : t ? vn : yn;
    case "left":
    case "right":
      return t ? qi : Gi;
    default:
      return [];
  }
}
function Ji(e, t, n, r) {
  const o = ke(e);
  let a = Qi(de(e), n === "start", r);
  return o && (a = a.map((c) => c + "-" + o), t && (a = a.concat(a.map(kt)))), a;
}
function rt(e) {
  return e.replace(/left|right|bottom|top/g, (t) => zi[t]);
}
function ea(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function ar(e) {
  return typeof e != "number" ? ea(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function ot(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: o
  } = e;
  return {
    width: r,
    height: o,
    top: n,
    left: t,
    right: t + r,
    bottom: n + o,
    x: t,
    y: n
  };
}
function wn(e, t, n) {
  let {
    reference: r,
    floating: o
  } = e;
  const a = ie(t), c = Yt(t), s = Kt(c), u = de(t), l = a === "y", f = r.x + r.width / 2 - o.width / 2, m = r.y + r.height / 2 - o.height / 2, p = r[s] / 2 - o[s] / 2;
  let h;
  switch (u) {
    case "top":
      h = {
        x: f,
        y: r.y - o.height
      };
      break;
    case "bottom":
      h = {
        x: f,
        y: r.y + r.height
      };
      break;
    case "right":
      h = {
        x: r.x + r.width,
        y: m
      };
      break;
    case "left":
      h = {
        x: r.x - o.width,
        y: m
      };
      break;
    default:
      h = {
        x: r.x,
        y: r.y
      };
  }
  switch (ke(t)) {
    case "start":
      h[c] -= p * (n && l ? -1 : 1);
      break;
    case "end":
      h[c] += p * (n && l ? -1 : 1);
      break;
  }
  return h;
}
const ta = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: a = [],
    platform: c
  } = n, s = a.filter(Boolean), u = await (c.isRTL == null ? void 0 : c.isRTL(t));
  let l = await c.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: f,
    y: m
  } = wn(l, r, u), p = r, h = {}, w = 0;
  for (let d = 0; d < s.length; d++) {
    const {
      name: g,
      fn: y
    } = s[d], {
      x: v,
      y: x,
      data: S,
      reset: E
    } = await y({
      x: f,
      y: m,
      initialPlacement: r,
      placement: p,
      strategy: o,
      middlewareData: h,
      rects: l,
      platform: c,
      elements: {
        reference: e,
        floating: t
      }
    });
    f = v ?? f, m = x ?? m, h = {
      ...h,
      [g]: {
        ...h[g],
        ...S
      }
    }, E && w <= 50 && (w++, typeof E == "object" && (E.placement && (p = E.placement), E.rects && (l = E.rects === !0 ? await c.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : E.rects), {
      x: f,
      y: m
    } = wn(l, p, u)), d = -1);
  }
  return {
    x: f,
    y: m,
    placement: p,
    strategy: o,
    middlewareData: h
  };
};
async function Ze(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: o,
    platform: a,
    rects: c,
    elements: s,
    strategy: u
  } = e, {
    boundary: l = "clippingAncestors",
    rootBoundary: f = "viewport",
    elementContext: m = "floating",
    altBoundary: p = !1,
    padding: h = 0
  } = ue(t, e), w = ar(h), g = s[p ? m === "floating" ? "reference" : "floating" : m], y = ot(await a.getClippingRect({
    element: (n = await (a.isElement == null ? void 0 : a.isElement(g))) == null || n ? g : g.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(s.floating)),
    boundary: l,
    rootBoundary: f,
    strategy: u
  })), v = m === "floating" ? {
    x: r,
    y: o,
    width: c.floating.width,
    height: c.floating.height
  } : c.reference, x = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(s.floating)), S = await (a.isElement == null ? void 0 : a.isElement(x)) ? await (a.getScale == null ? void 0 : a.getScale(x)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, E = ot(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: v,
    offsetParent: x,
    strategy: u
  }) : v);
  return {
    top: (y.top - E.top + w.top) / S.y,
    bottom: (E.bottom - y.bottom + w.bottom) / S.y,
    left: (y.left - E.left + w.left) / S.x,
    right: (E.right - y.right + w.right) / S.x
  };
}
const na = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: o,
      rects: a,
      platform: c,
      elements: s,
      middlewareData: u
    } = t, {
      element: l,
      padding: f = 0
    } = ue(e, t) || {};
    if (l == null)
      return {};
    const m = ar(f), p = {
      x: n,
      y: r
    }, h = Yt(o), w = Kt(h), d = await c.getDimensions(l), g = h === "y", y = g ? "top" : "left", v = g ? "bottom" : "right", x = g ? "clientHeight" : "clientWidth", S = a.reference[w] + a.reference[h] - p[h] - a.floating[w], E = p[h] - a.reference[h], A = await (c.getOffsetParent == null ? void 0 : c.getOffsetParent(l));
    let C = A ? A[x] : 0;
    (!C || !await (c.isElement == null ? void 0 : c.isElement(A))) && (C = s.floating[x] || a.floating[w]);
    const P = S / 2 - E / 2, k = C / 2 - d[w] / 2 - 1, O = he(m[y], k), V = he(m[v], k), B = O, L = C - d[w] - V, T = C / 2 - d[w] / 2 + P, U = It(B, T, L), M = !u.arrow && ke(o) != null && T !== U && a.reference[w] / 2 - (T < B ? O : V) - d[w] / 2 < 0, I = M ? T < B ? T - B : T - L : 0;
    return {
      [h]: p[h] + I,
      data: {
        [h]: U,
        centerOffset: T - U - I,
        ...M && {
          alignmentOffset: I
        }
      },
      reset: M
    };
  }
}), ra = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        middlewareData: a,
        rects: c,
        initialPlacement: s,
        platform: u,
        elements: l
      } = t, {
        mainAxis: f = !0,
        crossAxis: m = !0,
        fallbackPlacements: p,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: w = "none",
        flipAlignment: d = !0,
        ...g
      } = ue(e, t);
      if ((n = a.arrow) != null && n.alignmentOffset)
        return {};
      const y = de(o), v = ie(s), x = de(s) === s, S = await (u.isRTL == null ? void 0 : u.isRTL(l.floating)), E = p || (x || !d ? [rt(s)] : Xi(s)), A = w !== "none";
      !p && A && E.push(...Ji(s, d, w, S));
      const C = [s, ...E], P = await Ze(t, g), k = [];
      let O = ((r = a.flip) == null ? void 0 : r.overflows) || [];
      if (f && k.push(P[y]), m) {
        const T = Yi(o, c, S);
        k.push(P[T[0]], P[T[1]]);
      }
      if (O = [...O, {
        placement: o,
        overflows: k
      }], !k.every((T) => T <= 0)) {
        var V, B;
        const T = (((V = a.flip) == null ? void 0 : V.index) || 0) + 1, U = C[T];
        if (U && (!(m === "alignment" ? v !== ie(U) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        O.every((R) => ie(R.placement) === v ? R.overflows[0] > 0 : !0)))
          return {
            data: {
              index: T,
              overflows: O
            },
            reset: {
              placement: U
            }
          };
        let M = (B = O.filter((I) => I.overflows[0] <= 0).sort((I, R) => I.overflows[1] - R.overflows[1])[0]) == null ? void 0 : B.placement;
        if (!M)
          switch (h) {
            case "bestFit": {
              var L;
              const I = (L = O.filter((R) => {
                if (A) {
                  const $ = ie(R.placement);
                  return $ === v || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  $ === "y";
                }
                return !0;
              }).map((R) => [R.placement, R.overflows.filter(($) => $ > 0).reduce(($, X) => $ + X, 0)]).sort((R, $) => R[1] - $[1])[0]) == null ? void 0 : L[0];
              I && (M = I);
              break;
            }
            case "initialPlacement":
              M = s;
              break;
          }
        if (o !== M)
          return {
            reset: {
              placement: M
            }
          };
      }
      return {};
    }
  };
};
function bn(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function xn(e) {
  return Ui.some((t) => e[t] >= 0);
}
const oa = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: r = "referenceHidden",
        ...o
      } = ue(e, t);
      switch (r) {
        case "referenceHidden": {
          const a = await Ze(t, {
            ...o,
            elementContext: "reference"
          }), c = bn(a, n.reference);
          return {
            data: {
              referenceHiddenOffsets: c,
              referenceHidden: xn(c)
            }
          };
        }
        case "escaped": {
          const a = await Ze(t, {
            ...o,
            altBoundary: !0
          }), c = bn(a, n.floating);
          return {
            data: {
              escapedOffsets: c,
              escaped: xn(c)
            }
          };
        }
        default:
          return {};
      }
    }
  };
}, sr = /* @__PURE__ */ new Set(["left", "top"]);
async function ia(e, t) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = e, a = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), c = de(n), s = ke(n), u = ie(n) === "y", l = sr.has(c) ? -1 : 1, f = a && u ? -1 : 1, m = ue(t, e);
  let {
    mainAxis: p,
    crossAxis: h,
    alignmentAxis: w
  } = typeof m == "number" ? {
    mainAxis: m,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: m.mainAxis || 0,
    crossAxis: m.crossAxis || 0,
    alignmentAxis: m.alignmentAxis
  };
  return s && typeof w == "number" && (h = s === "end" ? w * -1 : w), u ? {
    x: h * f,
    y: p * l
  } : {
    x: p * l,
    y: h * f
  };
}
const aa = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: o,
        y: a,
        placement: c,
        middlewareData: s
      } = t, u = await ia(t, e);
      return c === ((n = s.offset) == null ? void 0 : n.placement) && (r = s.arrow) != null && r.alignmentOffset ? {} : {
        x: o + u.x,
        y: a + u.y,
        data: {
          ...u,
          placement: c
        }
      };
    }
  };
}, sa = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: o
      } = t, {
        mainAxis: a = !0,
        crossAxis: c = !1,
        limiter: s = {
          fn: (g) => {
            let {
              x: y,
              y: v
            } = g;
            return {
              x: y,
              y: v
            };
          }
        },
        ...u
      } = ue(e, t), l = {
        x: n,
        y: r
      }, f = await Ze(t, u), m = ie(de(o)), p = jt(m);
      let h = l[p], w = l[m];
      if (a) {
        const g = p === "y" ? "top" : "left", y = p === "y" ? "bottom" : "right", v = h + f[g], x = h - f[y];
        h = It(v, h, x);
      }
      if (c) {
        const g = m === "y" ? "top" : "left", y = m === "y" ? "bottom" : "right", v = w + f[g], x = w - f[y];
        w = It(v, w, x);
      }
      const d = s.fn({
        ...t,
        [p]: h,
        [m]: w
      });
      return {
        ...d,
        data: {
          x: d.x - n,
          y: d.y - r,
          enabled: {
            [p]: a,
            [m]: c
          }
        }
      };
    }
  };
}, ca = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: o,
        rects: a,
        middlewareData: c
      } = t, {
        offset: s = 0,
        mainAxis: u = !0,
        crossAxis: l = !0
      } = ue(e, t), f = {
        x: n,
        y: r
      }, m = ie(o), p = jt(m);
      let h = f[p], w = f[m];
      const d = ue(s, t), g = typeof d == "number" ? {
        mainAxis: d,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...d
      };
      if (u) {
        const x = p === "y" ? "height" : "width", S = a.reference[p] - a.floating[x] + g.mainAxis, E = a.reference[p] + a.reference[x] - g.mainAxis;
        h < S ? h = S : h > E && (h = E);
      }
      if (l) {
        var y, v;
        const x = p === "y" ? "width" : "height", S = sr.has(de(o)), E = a.reference[m] - a.floating[x] + (S && ((y = c.offset) == null ? void 0 : y[m]) || 0) + (S ? 0 : g.crossAxis), A = a.reference[m] + a.reference[x] + (S ? 0 : ((v = c.offset) == null ? void 0 : v[m]) || 0) - (S ? g.crossAxis : 0);
        w < E ? w = E : w > A && (w = A);
      }
      return {
        [p]: h,
        [m]: w
      };
    }
  };
}, la = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        rects: a,
        platform: c,
        elements: s
      } = t, {
        apply: u = () => {
        },
        ...l
      } = ue(e, t), f = await Ze(t, l), m = de(o), p = ke(o), h = ie(o) === "y", {
        width: w,
        height: d
      } = a.floating;
      let g, y;
      m === "top" || m === "bottom" ? (g = m, y = p === (await (c.isRTL == null ? void 0 : c.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (y = m, g = p === "end" ? "top" : "bottom");
      const v = d - f.top - f.bottom, x = w - f.left - f.right, S = he(d - f[g], v), E = he(w - f[y], x), A = !t.middlewareData.shift;
      let C = S, P = E;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (P = x), (r = t.middlewareData.shift) != null && r.enabled.y && (C = v), A && !p) {
        const O = G(f.left, 0), V = G(f.right, 0), B = G(f.top, 0), L = G(f.bottom, 0);
        h ? P = w - 2 * (O !== 0 || V !== 0 ? O + V : G(f.left, f.right)) : C = d - 2 * (B !== 0 || L !== 0 ? B + L : G(f.top, f.bottom));
      }
      await u({
        ...t,
        availableWidth: P,
        availableHeight: C
      });
      const k = await c.getDimensions(s.floating);
      return w !== k.width || d !== k.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function pt() {
  return typeof window < "u";
}
function Le(e) {
  return cr(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Q(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function ce(e) {
  var t;
  return (t = (cr(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function cr(e) {
  return pt() ? e instanceof Node || e instanceof Q(e).Node : !1;
}
function te(e) {
  return pt() ? e instanceof Element || e instanceof Q(e).Element : !1;
}
function se(e) {
  return pt() ? e instanceof HTMLElement || e instanceof Q(e).HTMLElement : !1;
}
function Sn(e) {
  return !pt() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Q(e).ShadowRoot;
}
const ua = /* @__PURE__ */ new Set(["inline", "contents"]);
function ze(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = ne(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !ua.has(o);
}
const da = /* @__PURE__ */ new Set(["table", "td", "th"]);
function fa(e) {
  return da.has(Le(e));
}
const ma = [":popover-open", ":modal"];
function ht(e) {
  return ma.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
const pa = ["transform", "translate", "scale", "rotate", "perspective"], ha = ["transform", "translate", "scale", "rotate", "perspective", "filter"], ga = ["paint", "layout", "strict", "content"];
function Xt(e) {
  const t = qt(), n = te(e) ? ne(e) : e;
  return pa.some((r) => n[r] ? n[r] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ha.some((r) => (n.willChange || "").includes(r)) || ga.some((r) => (n.contain || "").includes(r));
}
function va(e) {
  let t = ge(e);
  for (; se(t) && !Ie(t); ) {
    if (Xt(t))
      return t;
    if (ht(t))
      return null;
    t = ge(t);
  }
  return null;
}
function qt() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const ya = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function Ie(e) {
  return ya.has(Le(e));
}
function ne(e) {
  return Q(e).getComputedStyle(e);
}
function gt(e) {
  return te(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function ge(e) {
  if (Le(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Sn(e) && e.host || // Fallback.
    ce(e)
  );
  return Sn(t) ? t.host : t;
}
function lr(e) {
  const t = ge(e);
  return Ie(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : se(t) && ze(t) ? t : lr(t);
}
function Ue(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const o = lr(e), a = o === ((r = e.ownerDocument) == null ? void 0 : r.body), c = Q(o);
  if (a) {
    const s = Lt(c);
    return t.concat(c, c.visualViewport || [], ze(o) ? o : [], s && n ? Ue(s) : []);
  }
  return t.concat(o, Ue(o, [], n));
}
function Lt(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function ur(e) {
  const t = ne(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = se(e), a = o ? e.offsetWidth : n, c = o ? e.offsetHeight : r, s = nt(n) !== a || nt(r) !== c;
  return s && (n = a, r = c), {
    width: n,
    height: r,
    $: s
  };
}
function Gt(e) {
  return te(e) ? e : e.contextElement;
}
function Te(e) {
  const t = Gt(e);
  if (!se(t))
    return ae(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: a
  } = ur(t);
  let c = (a ? nt(n.width) : n.width) / r, s = (a ? nt(n.height) : n.height) / o;
  return (!c || !Number.isFinite(c)) && (c = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: c,
    y: s
  };
}
const wa = /* @__PURE__ */ ae(0);
function dr(e) {
  const t = Q(e);
  return !qt() || !t.visualViewport ? wa : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function ba(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== Q(e) ? !1 : t;
}
function Se(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), a = Gt(e);
  let c = ae(1);
  t && (r ? te(r) && (c = Te(r)) : c = Te(e));
  const s = ba(a, n, r) ? dr(a) : ae(0);
  let u = (o.left + s.x) / c.x, l = (o.top + s.y) / c.y, f = o.width / c.x, m = o.height / c.y;
  if (a) {
    const p = Q(a), h = r && te(r) ? Q(r) : r;
    let w = p, d = Lt(w);
    for (; d && r && h !== w; ) {
      const g = Te(d), y = d.getBoundingClientRect(), v = ne(d), x = y.left + (d.clientLeft + parseFloat(v.paddingLeft)) * g.x, S = y.top + (d.clientTop + parseFloat(v.paddingTop)) * g.y;
      u *= g.x, l *= g.y, f *= g.x, m *= g.y, u += x, l += S, w = Q(d), d = Lt(w);
    }
  }
  return ot({
    width: f,
    height: m,
    x: u,
    y: l
  });
}
function Qt(e, t) {
  const n = gt(e).scrollLeft;
  return t ? t.left + n : Se(ce(e)).left + n;
}
function fr(e, t, n) {
  n === void 0 && (n = !1);
  const r = e.getBoundingClientRect(), o = r.left + t.scrollLeft - (n ? 0 : (
    // RTL <body> scrollbar.
    Qt(e, r)
  )), a = r.top + t.scrollTop;
  return {
    x: o,
    y: a
  };
}
function xa(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: o
  } = e;
  const a = o === "fixed", c = ce(r), s = t ? ht(t.floating) : !1;
  if (r === c || s && a)
    return n;
  let u = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = ae(1);
  const f = ae(0), m = se(r);
  if ((m || !m && !a) && ((Le(r) !== "body" || ze(c)) && (u = gt(r)), se(r))) {
    const h = Se(r);
    l = Te(r), f.x = h.x + r.clientLeft, f.y = h.y + r.clientTop;
  }
  const p = c && !m && !a ? fr(c, u, !0) : ae(0);
  return {
    width: n.width * l.x,
    height: n.height * l.y,
    x: n.x * l.x - u.scrollLeft * l.x + f.x + p.x,
    y: n.y * l.y - u.scrollTop * l.y + f.y + p.y
  };
}
function Sa(e) {
  return Array.from(e.getClientRects());
}
function Ea(e) {
  const t = ce(e), n = gt(e), r = e.ownerDocument.body, o = G(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), a = G(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let c = -n.scrollLeft + Qt(e);
  const s = -n.scrollTop;
  return ne(r).direction === "rtl" && (c += G(t.clientWidth, r.clientWidth) - o), {
    width: o,
    height: a,
    x: c,
    y: s
  };
}
function Ca(e, t) {
  const n = Q(e), r = ce(e), o = n.visualViewport;
  let a = r.clientWidth, c = r.clientHeight, s = 0, u = 0;
  if (o) {
    a = o.width, c = o.height;
    const l = qt();
    (!l || l && t === "fixed") && (s = o.offsetLeft, u = o.offsetTop);
  }
  return {
    width: a,
    height: c,
    x: s,
    y: u
  };
}
const Aa = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function Ra(e, t) {
  const n = Se(e, !0, t === "fixed"), r = n.top + e.clientTop, o = n.left + e.clientLeft, a = se(e) ? Te(e) : ae(1), c = e.clientWidth * a.x, s = e.clientHeight * a.y, u = o * a.x, l = r * a.y;
  return {
    width: c,
    height: s,
    x: u,
    y: l
  };
}
function En(e, t, n) {
  let r;
  if (t === "viewport")
    r = Ca(e, n);
  else if (t === "document")
    r = Ea(ce(e));
  else if (te(t))
    r = Ra(t, n);
  else {
    const o = dr(e);
    r = {
      x: t.x - o.x,
      y: t.y - o.y,
      width: t.width,
      height: t.height
    };
  }
  return ot(r);
}
function mr(e, t) {
  const n = ge(e);
  return n === t || !te(n) || Ie(n) ? !1 : ne(n).position === "fixed" || mr(n, t);
}
function Na(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = Ue(e, [], !1).filter((s) => te(s) && Le(s) !== "body"), o = null;
  const a = ne(e).position === "fixed";
  let c = a ? ge(e) : e;
  for (; te(c) && !Ie(c); ) {
    const s = ne(c), u = Xt(c);
    !u && s.position === "fixed" && (o = null), (a ? !u && !o : !u && s.position === "static" && !!o && Aa.has(o.position) || ze(c) && !u && mr(e, c)) ? r = r.filter((f) => f !== c) : o = s, c = ge(c);
  }
  return t.set(e, r), r;
}
function Pa(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = e;
  const c = [...n === "clippingAncestors" ? ht(t) ? [] : Na(t, this._c) : [].concat(n), r], s = c[0], u = c.reduce((l, f) => {
    const m = En(t, f, o);
    return l.top = G(m.top, l.top), l.right = he(m.right, l.right), l.bottom = he(m.bottom, l.bottom), l.left = G(m.left, l.left), l;
  }, En(t, s, o));
  return {
    width: u.right - u.left,
    height: u.bottom - u.top,
    x: u.left,
    y: u.top
  };
}
function Ma(e) {
  const {
    width: t,
    height: n
  } = ur(e);
  return {
    width: t,
    height: n
  };
}
function Ta(e, t, n) {
  const r = se(t), o = ce(t), a = n === "fixed", c = Se(e, !0, a, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const u = ae(0);
  function l() {
    u.x = Qt(o);
  }
  if (r || !r && !a)
    if ((Le(t) !== "body" || ze(o)) && (s = gt(t)), r) {
      const h = Se(t, !0, a, t);
      u.x = h.x + t.clientLeft, u.y = h.y + t.clientTop;
    } else o && l();
  a && !r && o && l();
  const f = o && !r && !a ? fr(o, s) : ae(0), m = c.left + s.scrollLeft - u.x - f.x, p = c.top + s.scrollTop - u.y - f.y;
  return {
    x: m,
    y: p,
    width: c.width,
    height: c.height
  };
}
function Ct(e) {
  return ne(e).position === "static";
}
function Cn(e, t) {
  if (!se(e) || ne(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return ce(e) === n && (n = n.ownerDocument.body), n;
}
function pr(e, t) {
  const n = Q(e);
  if (ht(e))
    return n;
  if (!se(e)) {
    let o = ge(e);
    for (; o && !Ie(o); ) {
      if (te(o) && !Ct(o))
        return o;
      o = ge(o);
    }
    return n;
  }
  let r = Cn(e, t);
  for (; r && fa(r) && Ct(r); )
    r = Cn(r, t);
  return r && Ie(r) && Ct(r) && !Xt(r) ? n : r || va(e) || n;
}
const Oa = async function(e) {
  const t = this.getOffsetParent || pr, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: Ta(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function Ia(e) {
  return ne(e).direction === "rtl";
}
const ka = {
  convertOffsetParentRelativeRectToViewportRelativeRect: xa,
  getDocumentElement: ce,
  getClippingRect: Pa,
  getOffsetParent: pr,
  getElementRects: Oa,
  getClientRects: Sa,
  getDimensions: Ma,
  getScale: Te,
  isElement: te,
  isRTL: Ia
};
function hr(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function La(e, t) {
  let n = null, r;
  const o = ce(e);
  function a() {
    var s;
    clearTimeout(r), (s = n) == null || s.disconnect(), n = null;
  }
  function c(s, u) {
    s === void 0 && (s = !1), u === void 0 && (u = 1), a();
    const l = e.getBoundingClientRect(), {
      left: f,
      top: m,
      width: p,
      height: h
    } = l;
    if (s || t(), !p || !h)
      return;
    const w = Ye(m), d = Ye(o.clientWidth - (f + p)), g = Ye(o.clientHeight - (m + h)), y = Ye(f), x = {
      rootMargin: -w + "px " + -d + "px " + -g + "px " + -y + "px",
      threshold: G(0, he(1, u)) || 1
    };
    let S = !0;
    function E(A) {
      const C = A[0].intersectionRatio;
      if (C !== u) {
        if (!S)
          return c();
        C ? c(!1, C) : r = setTimeout(() => {
          c(!1, 1e-7);
        }, 1e3);
      }
      C === 1 && !hr(l, e.getBoundingClientRect()) && c(), S = !1;
    }
    try {
      n = new IntersectionObserver(E, {
        ...x,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(E, x);
    }
    n.observe(e);
  }
  return c(!0), a;
}
function _a(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: a = !0,
    elementResize: c = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: u = !1
  } = r, l = Gt(e), f = o || a ? [...l ? Ue(l) : [], ...Ue(t)] : [];
  f.forEach((y) => {
    o && y.addEventListener("scroll", n, {
      passive: !0
    }), a && y.addEventListener("resize", n);
  });
  const m = l && s ? La(l, n) : null;
  let p = -1, h = null;
  c && (h = new ResizeObserver((y) => {
    let [v] = y;
    v && v.target === l && h && (h.unobserve(t), cancelAnimationFrame(p), p = requestAnimationFrame(() => {
      var x;
      (x = h) == null || x.observe(t);
    })), n();
  }), l && !u && h.observe(l), h.observe(t));
  let w, d = u ? Se(e) : null;
  u && g();
  function g() {
    const y = Se(e);
    d && !hr(d, y) && n(), d = y, w = requestAnimationFrame(g);
  }
  return n(), () => {
    var y;
    f.forEach((v) => {
      o && v.removeEventListener("scroll", n), a && v.removeEventListener("resize", n);
    }), m == null || m(), (y = h) == null || y.disconnect(), h = null, u && cancelAnimationFrame(w);
  };
}
const Da = aa, Fa = sa, Ha = ra, Va = la, Ba = oa, An = na, $a = ca, Wa = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: ka,
    ...n
  }, a = {
    ...o.platform,
    _c: r
  };
  return ta(e, t, {
    ...o,
    platform: a
  });
};
var Za = typeof document < "u", Ua = function() {
}, Je = Za ? To : Ua;
function it(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (r = n; r-- !== 0; )
        if (!it(e[r], t[r]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const a = o[r];
      if (!(a === "_owner" && e.$$typeof) && !it(e[a], t[a]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function gr(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Rn(e, t) {
  const n = gr(e);
  return Math.round(t * n) / n;
}
function At(e) {
  const t = i.useRef(e);
  return Je(() => {
    t.current = e;
  }), t;
}
function za(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: o,
    elements: {
      reference: a,
      floating: c
    } = {},
    transform: s = !0,
    whileElementsMounted: u,
    open: l
  } = e, [f, m] = i.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [p, h] = i.useState(r);
  it(p, r) || h(r);
  const [w, d] = i.useState(null), [g, y] = i.useState(null), v = i.useCallback((R) => {
    R !== A.current && (A.current = R, d(R));
  }, []), x = i.useCallback((R) => {
    R !== C.current && (C.current = R, y(R));
  }, []), S = a || w, E = c || g, A = i.useRef(null), C = i.useRef(null), P = i.useRef(f), k = u != null, O = At(u), V = At(o), B = At(l), L = i.useCallback(() => {
    if (!A.current || !C.current)
      return;
    const R = {
      placement: t,
      strategy: n,
      middleware: p
    };
    V.current && (R.platform = V.current), Wa(A.current, C.current, R).then(($) => {
      const X = {
        ...$,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: B.current !== !1
      };
      T.current && !it(P.current, X) && (P.current = X, ct.flushSync(() => {
        m(X);
      }));
    });
  }, [p, t, n, V, B]);
  Je(() => {
    l === !1 && P.current.isPositioned && (P.current.isPositioned = !1, m((R) => ({
      ...R,
      isPositioned: !1
    })));
  }, [l]);
  const T = i.useRef(!1);
  Je(() => (T.current = !0, () => {
    T.current = !1;
  }), []), Je(() => {
    if (S && (A.current = S), E && (C.current = E), S && E) {
      if (O.current)
        return O.current(S, E, L);
      L();
    }
  }, [S, E, L, O, k]);
  const U = i.useMemo(() => ({
    reference: A,
    floating: C,
    setReference: v,
    setFloating: x
  }), [v, x]), M = i.useMemo(() => ({
    reference: S,
    floating: E
  }), [S, E]), I = i.useMemo(() => {
    const R = {
      position: n,
      left: 0,
      top: 0
    };
    if (!M.floating)
      return R;
    const $ = Rn(M.floating, f.x), X = Rn(M.floating, f.y);
    return s ? {
      ...R,
      transform: "translate(" + $ + "px, " + X + "px)",
      ...gr(M.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: $,
      top: X
    };
  }, [n, s, M.floating, f.x, f.y]);
  return i.useMemo(() => ({
    ...f,
    update: L,
    refs: U,
    elements: M,
    floatingStyles: I
  }), [f, L, U, M, I]);
}
const ja = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: o
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? An({
        element: r.current,
        padding: o
      }).fn(n) : {} : r ? An({
        element: r,
        padding: o
      }).fn(n) : {};
    }
  };
}, Ka = (e, t) => ({
  ...Da(e),
  options: [e, t]
}), Ya = (e, t) => ({
  ...Fa(e),
  options: [e, t]
}), Xa = (e, t) => ({
  ...$a(e),
  options: [e, t]
}), qa = (e, t) => ({
  ...Ha(e),
  options: [e, t]
}), Ga = (e, t) => ({
  ...Va(e),
  options: [e, t]
}), Qa = (e, t) => ({
  ...Ba(e),
  options: [e, t]
}), Ja = (e, t) => ({
  ...ja(e),
  options: [e, t]
});
var es = "Arrow", vr = i.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: o = 5, ...a } = e;
  return /* @__PURE__ */ b(
    Z.svg,
    {
      ...a,
      ref: t,
      width: r,
      height: o,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ b("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
vr.displayName = es;
var ts = vr, Jt = "Popper", [yr, wr] = dt(Jt), [ns, br] = yr(Jt), xr = (e) => {
  const { __scopePopper: t, children: n } = e, [r, o] = i.useState(null);
  return /* @__PURE__ */ b(ns, { scope: t, anchor: r, onAnchorChange: o, children: n });
};
xr.displayName = Jt;
var Sr = "PopperAnchor", Er = i.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...o } = e, a = br(Sr, n), c = i.useRef(null), s = j(t, c), u = i.useRef(null);
    return i.useEffect(() => {
      const l = u.current;
      u.current = (r == null ? void 0 : r.current) || c.current, l !== u.current && a.onAnchorChange(u.current);
    }), r ? null : /* @__PURE__ */ b(Z.div, { ...o, ref: s });
  }
);
Er.displayName = Sr;
var en = "PopperContent", [rs, os] = yr(en), Cr = i.forwardRef(
  (e, t) => {
    var N, W, K, H, _, D;
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: o = 0,
      align: a = "center",
      alignOffset: c = 0,
      arrowPadding: s = 0,
      avoidCollisions: u = !0,
      collisionBoundary: l = [],
      collisionPadding: f = 0,
      sticky: m = "partial",
      hideWhenDetached: p = !1,
      updatePositionStrategy: h = "optimized",
      onPlaced: w,
      ...d
    } = e, g = br(en, n), [y, v] = i.useState(null), x = j(t, (q) => v(q)), [S, E] = i.useState(null), A = Bn(S), C = (A == null ? void 0 : A.width) ?? 0, P = (A == null ? void 0 : A.height) ?? 0, k = r + (a !== "center" ? "-" + a : ""), O = typeof f == "number" ? f : { top: 0, right: 0, bottom: 0, left: 0, ...f }, V = Array.isArray(l) ? l : [l], B = V.length > 0, L = {
      padding: O,
      boundary: V.filter(as),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: B
    }, { refs: T, floatingStyles: U, placement: M, isPositioned: I, middlewareData: R } = za({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: k,
      whileElementsMounted: (...q) => _a(...q, {
        animationFrame: h === "always"
      }),
      elements: {
        reference: g.anchor
      },
      middleware: [
        Ka({ mainAxis: o + P, alignmentAxis: c }),
        u && Ya({
          mainAxis: !0,
          crossAxis: !1,
          limiter: m === "partial" ? Xa() : void 0,
          ...L
        }),
        u && qa({ ...L }),
        Ga({
          ...L,
          apply: ({ elements: q, rects: re, availableWidth: He, availableHeight: Ve }) => {
            const { width: Be, height: Po } = re.reference, je = q.floating.style;
            je.setProperty("--radix-popper-available-width", `${He}px`), je.setProperty("--radix-popper-available-height", `${Ve}px`), je.setProperty("--radix-popper-anchor-width", `${Be}px`), je.setProperty("--radix-popper-anchor-height", `${Po}px`);
          }
        }),
        S && Ja({ element: S, padding: s }),
        ss({ arrowWidth: C, arrowHeight: P }),
        p && Qa({ strategy: "referenceHidden", ...L })
      ]
    }), [$, X] = Nr(M), le = xe(w);
    Y(() => {
      I && (le == null || le());
    }, [I, le]);
    const De = (N = R.arrow) == null ? void 0 : N.x, Fe = (W = R.arrow) == null ? void 0 : W.y, fe = ((K = R.arrow) == null ? void 0 : K.centerOffset) !== 0, [Re, we] = i.useState();
    return Y(() => {
      y && we(window.getComputedStyle(y).zIndex);
    }, [y]), /* @__PURE__ */ b(
      "div",
      {
        ref: T.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...U,
          transform: I ? U.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: Re,
          "--radix-popper-transform-origin": [
            (H = R.transformOrigin) == null ? void 0 : H.x,
            (_ = R.transformOrigin) == null ? void 0 : _.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((D = R.hide) == null ? void 0 : D.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ b(
          rs,
          {
            scope: n,
            placedSide: $,
            onArrowChange: E,
            arrowX: De,
            arrowY: Fe,
            shouldHideArrow: fe,
            children: /* @__PURE__ */ b(
              Z.div,
              {
                "data-side": $,
                "data-align": X,
                ...d,
                ref: x,
                style: {
                  ...d.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: I ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
Cr.displayName = en;
var Ar = "PopperArrow", is = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, Rr = i.forwardRef(function(t, n) {
  const { __scopePopper: r, ...o } = t, a = os(Ar, r), c = is[a.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ b(
      "span",
      {
        ref: a.onArrowChange,
        style: {
          position: "absolute",
          left: a.arrowX,
          top: a.arrowY,
          [c]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[a.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[a.placedSide],
          visibility: a.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ b(
          ts,
          {
            ...o,
            ref: n,
            style: {
              ...o.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
Rr.displayName = Ar;
function as(e) {
  return e !== null;
}
var ss = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var g, y, v;
    const { placement: n, rects: r, middlewareData: o } = t, c = ((g = o.arrow) == null ? void 0 : g.centerOffset) !== 0, s = c ? 0 : e.arrowWidth, u = c ? 0 : e.arrowHeight, [l, f] = Nr(n), m = { start: "0%", center: "50%", end: "100%" }[f], p = (((y = o.arrow) == null ? void 0 : y.x) ?? 0) + s / 2, h = (((v = o.arrow) == null ? void 0 : v.y) ?? 0) + u / 2;
    let w = "", d = "";
    return l === "bottom" ? (w = c ? m : `${p}px`, d = `${-u}px`) : l === "top" ? (w = c ? m : `${p}px`, d = `${r.floating.height + u}px`) : l === "right" ? (w = `${-u}px`, d = c ? m : `${h}px`) : l === "left" && (w = `${r.floating.width + u}px`, d = c ? m : `${h}px`), { data: { x: w, y: d } };
  }
});
function Nr(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var cs = xr, ls = Er, us = Cr, ds = Rr, fs = "Portal", Pr = i.forwardRef((e, t) => {
  var s;
  const { container: n, ...r } = e, [o, a] = i.useState(!1);
  Y(() => a(!0), []);
  const c = n || o && ((s = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : s.body);
  return c ? Io.createPortal(/* @__PURE__ */ b(Z.div, { ...r, ref: t }), c) : null;
});
Pr.displayName = fs;
var Mr = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), ms = "VisuallyHidden", ps = i.forwardRef(
  (e, t) => /* @__PURE__ */ b(
    Z.span,
    {
      ...e,
      ref: t,
      style: { ...Mr, ...e.style }
    }
  )
);
ps.displayName = ms;
var hs = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, Ne = /* @__PURE__ */ new WeakMap(), Xe = /* @__PURE__ */ new WeakMap(), qe = {}, Rt = 0, Tr = function(e) {
  return e && (e.host || Tr(e.parentNode));
}, gs = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = Tr(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, vs = function(e, t, n, r) {
  var o = gs(t, Array.isArray(e) ? e : [e]);
  qe[n] || (qe[n] = /* @__PURE__ */ new WeakMap());
  var a = qe[n], c = [], s = /* @__PURE__ */ new Set(), u = new Set(o), l = function(m) {
    !m || s.has(m) || (s.add(m), l(m.parentNode));
  };
  o.forEach(l);
  var f = function(m) {
    !m || u.has(m) || Array.prototype.forEach.call(m.children, function(p) {
      if (s.has(p))
        f(p);
      else
        try {
          var h = p.getAttribute(r), w = h !== null && h !== "false", d = (Ne.get(p) || 0) + 1, g = (a.get(p) || 0) + 1;
          Ne.set(p, d), a.set(p, g), c.push(p), d === 1 && w && Xe.set(p, !0), g === 1 && p.setAttribute(n, "true"), w || p.setAttribute(r, "true");
        } catch (y) {
          console.error("aria-hidden: cannot operate on ", p, y);
        }
    });
  };
  return f(t), s.clear(), Rt++, function() {
    c.forEach(function(m) {
      var p = Ne.get(m) - 1, h = a.get(m) - 1;
      Ne.set(m, p), a.set(m, h), p || (Xe.has(m) || m.removeAttribute(r), Xe.delete(m)), h || m.removeAttribute(n);
    }), Rt--, Rt || (Ne = /* @__PURE__ */ new WeakMap(), Ne = /* @__PURE__ */ new WeakMap(), Xe = /* @__PURE__ */ new WeakMap(), qe = {});
  };
}, ys = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), o = hs(e);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live], script"))), vs(r, o, n, "aria-hidden")) : function() {
    return null;
  };
}, oe = function() {
  return oe = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, oe.apply(this, arguments);
};
function Or(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function ws(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, o = t.length, a; r < o; r++)
    (a || !(r in t)) && (a || (a = Array.prototype.slice.call(t, 0, r)), a[r] = t[r]);
  return e.concat(a || Array.prototype.slice.call(t));
}
var et = "right-scroll-bar-position", tt = "width-before-scroll-bar", bs = "with-scroll-bars-hidden", xs = "--removed-body-scroll-bar-size";
function Nt(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function Ss(e, t) {
  var n = Oo(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var Es = typeof window < "u" ? i.useLayoutEffect : i.useEffect, Nn = /* @__PURE__ */ new WeakMap();
function Cs(e, t) {
  var n = Ss(null, function(r) {
    return e.forEach(function(o) {
      return Nt(o, r);
    });
  });
  return Es(function() {
    var r = Nn.get(n);
    if (r) {
      var o = new Set(r), a = new Set(e), c = n.current;
      o.forEach(function(s) {
        a.has(s) || Nt(s, null);
      }), a.forEach(function(s) {
        o.has(s) || Nt(s, c);
      });
    }
    Nn.set(n, e);
  }, [e]), n;
}
function As(e) {
  return e;
}
function Rs(e, t) {
  t === void 0 && (t = As);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(a) {
      var c = t(a, r);
      return n.push(c), function() {
        n = n.filter(function(s) {
          return s !== c;
        });
      };
    },
    assignSyncMedium: function(a) {
      for (r = !0; n.length; ) {
        var c = n;
        n = [], c.forEach(a);
      }
      n = {
        push: function(s) {
          return a(s);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(a) {
      r = !0;
      var c = [];
      if (n.length) {
        var s = n;
        n = [], s.forEach(a), c = n;
      }
      var u = function() {
        var f = c;
        c = [], f.forEach(a);
      }, l = function() {
        return Promise.resolve().then(u);
      };
      l(), n = {
        push: function(f) {
          c.push(f), l();
        },
        filter: function(f) {
          return c = c.filter(f), n;
        }
      };
    }
  };
  return o;
}
function Ns(e) {
  e === void 0 && (e = {});
  var t = Rs(null);
  return t.options = oe({ async: !0, ssr: !1 }, e), t;
}
var Ir = function(e) {
  var t = e.sideCar, n = Or(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return i.createElement(r, oe({}, n));
};
Ir.isSideCarExport = !0;
function Ps(e, t) {
  return e.useMedium(t), Ir;
}
var kr = Ns(), Pt = function() {
}, vt = i.forwardRef(function(e, t) {
  var n = i.useRef(null), r = i.useState({
    onScrollCapture: Pt,
    onWheelCapture: Pt,
    onTouchMoveCapture: Pt
  }), o = r[0], a = r[1], c = e.forwardProps, s = e.children, u = e.className, l = e.removeScrollBar, f = e.enabled, m = e.shards, p = e.sideCar, h = e.noRelative, w = e.noIsolation, d = e.inert, g = e.allowPinchZoom, y = e.as, v = y === void 0 ? "div" : y, x = e.gapMode, S = Or(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), E = p, A = Cs([n, t]), C = oe(oe({}, S), o);
  return i.createElement(
    i.Fragment,
    null,
    f && i.createElement(E, { sideCar: kr, removeScrollBar: l, shards: m, noRelative: h, noIsolation: w, inert: d, setCallbacks: a, allowPinchZoom: !!g, lockRef: n, gapMode: x }),
    c ? i.cloneElement(i.Children.only(s), oe(oe({}, C), { ref: A })) : i.createElement(v, oe({}, C, { className: u, ref: A }), s)
  );
});
vt.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
vt.classNames = {
  fullWidth: tt,
  zeroRight: et
};
var Ms = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function Ts() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = Ms();
  return t && e.setAttribute("nonce", t), e;
}
function Os(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function Is(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var ks = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = Ts()) && (Os(t, n), Is(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, Ls = function() {
  var e = ks();
  return function(t, n) {
    i.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, Lr = function() {
  var e = Ls(), t = function(n) {
    var r = n.styles, o = n.dynamic;
    return e(r, o), null;
  };
  return t;
}, _s = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Mt = function(e) {
  return parseInt(e || "", 10) || 0;
}, Ds = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [Mt(n), Mt(r), Mt(o)];
}, Fs = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return _s;
  var t = Ds(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, Hs = Lr(), Oe = "data-scroll-locked", Vs = function(e, t, n, r) {
  var o = e.left, a = e.top, c = e.right, s = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(bs, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(s, "px ").concat(r, `;
  }
  body[`).concat(Oe, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(a, `px;
    padding-right: `).concat(c, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(s, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(et, ` {
    right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(tt, ` {
    margin-right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(et, " .").concat(et, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(tt, " .").concat(tt, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(Oe, `] {
    `).concat(xs, ": ").concat(s, `px;
  }
`);
}, Pn = function() {
  var e = parseInt(document.body.getAttribute(Oe) || "0", 10);
  return isFinite(e) ? e : 0;
}, Bs = function() {
  i.useEffect(function() {
    return document.body.setAttribute(Oe, (Pn() + 1).toString()), function() {
      var e = Pn() - 1;
      e <= 0 ? document.body.removeAttribute(Oe) : document.body.setAttribute(Oe, e.toString());
    };
  }, []);
}, $s = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, o = r === void 0 ? "margin" : r;
  Bs();
  var a = i.useMemo(function() {
    return Fs(o);
  }, [o]);
  return i.createElement(Hs, { styles: Vs(a, !t, o, n ? "" : "!important") });
}, _t = !1;
if (typeof window < "u")
  try {
    var Ge = Object.defineProperty({}, "passive", {
      get: function() {
        return _t = !0, !0;
      }
    });
    window.addEventListener("test", Ge, Ge), window.removeEventListener("test", Ge, Ge);
  } catch {
    _t = !1;
  }
var Pe = _t ? { passive: !1 } : !1, Ws = function(e) {
  return e.tagName === "TEXTAREA";
}, _r = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !Ws(e) && n[t] === "visible")
  );
}, Zs = function(e) {
  return _r(e, "overflowY");
}, Us = function(e) {
  return _r(e, "overflowX");
}, Mn = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var o = Dr(e, r);
    if (o) {
      var a = Fr(e, r), c = a[1], s = a[2];
      if (c > s)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, zs = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, js = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, Dr = function(e, t) {
  return e === "v" ? Zs(t) : Us(t);
}, Fr = function(e, t) {
  return e === "v" ? zs(t) : js(t);
}, Ks = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, Ys = function(e, t, n, r, o) {
  var a = Ks(e, window.getComputedStyle(t).direction), c = a * r, s = n.target, u = t.contains(s), l = !1, f = c > 0, m = 0, p = 0;
  do {
    if (!s)
      break;
    var h = Fr(e, s), w = h[0], d = h[1], g = h[2], y = d - g - a * w;
    (w || y) && Dr(e, s) && (m += y, p += w);
    var v = s.parentNode;
    s = v && v.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? v.host : v;
  } while (
    // portaled content
    !u && s !== document.body || // self content
    u && (t.contains(s) || t === s)
  );
  return (f && Math.abs(m) < 1 || !f && Math.abs(p) < 1) && (l = !0), l;
}, Qe = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Tn = function(e) {
  return [e.deltaX, e.deltaY];
}, On = function(e) {
  return e && "current" in e ? e.current : e;
}, Xs = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, qs = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, Gs = 0, Me = [];
function Qs(e) {
  var t = i.useRef([]), n = i.useRef([0, 0]), r = i.useRef(), o = i.useState(Gs++)[0], a = i.useState(Lr)[0], c = i.useRef(e);
  i.useEffect(function() {
    c.current = e;
  }, [e]), i.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var d = ws([e.lockRef.current], (e.shards || []).map(On), !0).filter(Boolean);
      return d.forEach(function(g) {
        return g.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), d.forEach(function(g) {
          return g.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = i.useCallback(function(d, g) {
    if ("touches" in d && d.touches.length === 2 || d.type === "wheel" && d.ctrlKey)
      return !c.current.allowPinchZoom;
    var y = Qe(d), v = n.current, x = "deltaX" in d ? d.deltaX : v[0] - y[0], S = "deltaY" in d ? d.deltaY : v[1] - y[1], E, A = d.target, C = Math.abs(x) > Math.abs(S) ? "h" : "v";
    if ("touches" in d && C === "h" && A.type === "range")
      return !1;
    var P = Mn(C, A);
    if (!P)
      return !0;
    if (P ? E = C : (E = C === "v" ? "h" : "v", P = Mn(C, A)), !P)
      return !1;
    if (!r.current && "changedTouches" in d && (x || S) && (r.current = E), !E)
      return !0;
    var k = r.current || E;
    return Ys(k, g, d, k === "h" ? x : S);
  }, []), u = i.useCallback(function(d) {
    var g = d;
    if (!(!Me.length || Me[Me.length - 1] !== a)) {
      var y = "deltaY" in g ? Tn(g) : Qe(g), v = t.current.filter(function(E) {
        return E.name === g.type && (E.target === g.target || g.target === E.shadowParent) && Xs(E.delta, y);
      })[0];
      if (v && v.should) {
        g.cancelable && g.preventDefault();
        return;
      }
      if (!v) {
        var x = (c.current.shards || []).map(On).filter(Boolean).filter(function(E) {
          return E.contains(g.target);
        }), S = x.length > 0 ? s(g, x[0]) : !c.current.noIsolation;
        S && g.cancelable && g.preventDefault();
      }
    }
  }, []), l = i.useCallback(function(d, g, y, v) {
    var x = { name: d, delta: g, target: y, should: v, shadowParent: Js(y) };
    t.current.push(x), setTimeout(function() {
      t.current = t.current.filter(function(S) {
        return S !== x;
      });
    }, 1);
  }, []), f = i.useCallback(function(d) {
    n.current = Qe(d), r.current = void 0;
  }, []), m = i.useCallback(function(d) {
    l(d.type, Tn(d), d.target, s(d, e.lockRef.current));
  }, []), p = i.useCallback(function(d) {
    l(d.type, Qe(d), d.target, s(d, e.lockRef.current));
  }, []);
  i.useEffect(function() {
    return Me.push(a), e.setCallbacks({
      onScrollCapture: m,
      onWheelCapture: m,
      onTouchMoveCapture: p
    }), document.addEventListener("wheel", u, Pe), document.addEventListener("touchmove", u, Pe), document.addEventListener("touchstart", f, Pe), function() {
      Me = Me.filter(function(d) {
        return d !== a;
      }), document.removeEventListener("wheel", u, Pe), document.removeEventListener("touchmove", u, Pe), document.removeEventListener("touchstart", f, Pe);
    };
  }, []);
  var h = e.removeScrollBar, w = e.inert;
  return i.createElement(
    i.Fragment,
    null,
    w ? i.createElement(a, { styles: qs(o) }) : null,
    h ? i.createElement($s, { noRelative: e.noRelative, gapMode: e.gapMode }) : null
  );
}
function Js(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const ec = Ps(kr, Qs);
var Hr = i.forwardRef(function(e, t) {
  return i.createElement(vt, oe({}, e, { ref: t, sideCar: ec }));
});
Hr.classNames = vt.classNames;
var tc = [" ", "Enter", "ArrowUp", "ArrowDown"], nc = [" ", "Enter"], Ee = "Select", [yt, wt, rc] = Ei(Ee), [_e, Uc] = dt(Ee, [
  rc,
  wr
]), bt = wr(), [oc, ve] = _e(Ee), [ic, ac] = _e(Ee), Vr = (e) => {
  const {
    __scopeSelect: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: a,
    value: c,
    defaultValue: s,
    onValueChange: u,
    dir: l,
    name: f,
    autoComplete: m,
    disabled: p,
    required: h,
    form: w
  } = e, d = bt(t), [g, y] = i.useState(null), [v, x] = i.useState(null), [S, E] = i.useState(!1), A = Ai(l), [C, P] = Tt({
    prop: r,
    defaultProp: o ?? !1,
    onChange: a,
    caller: Ee
  }), [k, O] = Tt({
    prop: c,
    defaultProp: s,
    onChange: u,
    caller: Ee
  }), V = i.useRef(null), B = g ? w || !!g.closest("form") : !0, [L, T] = i.useState(/* @__PURE__ */ new Set()), U = Array.from(L).map((M) => M.props.value).join(";");
  return /* @__PURE__ */ b(cs, { ...d, children: /* @__PURE__ */ J(
    oc,
    {
      required: h,
      scope: t,
      trigger: g,
      onTriggerChange: y,
      valueNode: v,
      onValueNodeChange: x,
      valueNodeHasChildren: S,
      onValueNodeHasChildrenChange: E,
      contentId: zt(),
      value: k,
      onValueChange: O,
      open: C,
      onOpenChange: P,
      dir: A,
      triggerPointerDownPosRef: V,
      disabled: p,
      children: [
        /* @__PURE__ */ b(yt.Provider, { scope: t, children: /* @__PURE__ */ b(
          ic,
          {
            scope: e.__scopeSelect,
            onNativeOptionAdd: i.useCallback((M) => {
              T((I) => new Set(I).add(M));
            }, []),
            onNativeOptionRemove: i.useCallback((M) => {
              T((I) => {
                const R = new Set(I);
                return R.delete(M), R;
              });
            }, []),
            children: n
          }
        ) }),
        B ? /* @__PURE__ */ J(
          uo,
          {
            "aria-hidden": !0,
            required: h,
            tabIndex: -1,
            name: f,
            autoComplete: m,
            value: k,
            onChange: (M) => O(M.target.value),
            disabled: p,
            form: w,
            children: [
              k === void 0 ? /* @__PURE__ */ b("option", { value: "" }) : null,
              Array.from(L)
            ]
          },
          U
        ) : null
      ]
    }
  ) });
};
Vr.displayName = Ee;
var Br = "SelectTrigger", $r = i.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, disabled: r = !1, ...o } = e, a = bt(n), c = ve(Br, n), s = c.disabled || r, u = j(t, c.onTriggerChange), l = wt(n), f = i.useRef("touch"), [m, p, h] = mo((d) => {
      const g = l().filter((x) => !x.disabled), y = g.find((x) => x.value === c.value), v = po(g, d, y);
      v !== void 0 && c.onValueChange(v.value);
    }), w = (d) => {
      s || (c.onOpenChange(!0), h()), d && (c.triggerPointerDownPosRef.current = {
        x: Math.round(d.pageX),
        y: Math.round(d.pageY)
      });
    };
    return /* @__PURE__ */ b(ls, { asChild: !0, ...a, children: /* @__PURE__ */ b(
      Z.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": c.contentId,
        "aria-expanded": c.open,
        "aria-required": c.required,
        "aria-autocomplete": "none",
        dir: c.dir,
        "data-state": c.open ? "open" : "closed",
        disabled: s,
        "data-disabled": s ? "" : void 0,
        "data-placeholder": fo(c.value) ? "" : void 0,
        ...o,
        ref: u,
        onClick: z(o.onClick, (d) => {
          d.currentTarget.focus(), f.current !== "mouse" && w(d);
        }),
        onPointerDown: z(o.onPointerDown, (d) => {
          f.current = d.pointerType;
          const g = d.target;
          g.hasPointerCapture(d.pointerId) && g.releasePointerCapture(d.pointerId), d.button === 0 && d.ctrlKey === !1 && d.pointerType === "mouse" && (w(d), d.preventDefault());
        }),
        onKeyDown: z(o.onKeyDown, (d) => {
          const g = m.current !== "";
          !(d.ctrlKey || d.altKey || d.metaKey) && d.key.length === 1 && p(d.key), !(g && d.key === " ") && tc.includes(d.key) && (w(), d.preventDefault());
        })
      }
    ) });
  }
);
$r.displayName = Br;
var Wr = "SelectValue", Zr = i.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: o, children: a, placeholder: c = "", ...s } = e, u = ve(Wr, n), { onValueNodeHasChildrenChange: l } = u, f = a !== void 0, m = j(t, u.onValueNodeChange);
    return Y(() => {
      l(f);
    }, [l, f]), /* @__PURE__ */ b(
      Z.span,
      {
        ...s,
        ref: m,
        style: { pointerEvents: "none" },
        children: fo(u.value) ? /* @__PURE__ */ b(st, { children: c }) : a
      }
    );
  }
);
Zr.displayName = Wr;
var sc = "SelectIcon", Ur = i.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, children: r, ...o } = e;
    return /* @__PURE__ */ b(Z.span, { "aria-hidden": !0, ...o, ref: t, children: r || "▼" });
  }
);
Ur.displayName = sc;
var cc = "SelectPortal", zr = (e) => /* @__PURE__ */ b(Pr, { asChild: !0, ...e });
zr.displayName = cc;
var Ce = "SelectContent", jr = i.forwardRef(
  (e, t) => {
    const n = ve(Ce, e.__scopeSelect), [r, o] = i.useState();
    if (Y(() => {
      o(new DocumentFragment());
    }, []), !n.open) {
      const a = r;
      return a ? ct.createPortal(
        /* @__PURE__ */ b(Kr, { scope: e.__scopeSelect, children: /* @__PURE__ */ b(yt.Slot, { scope: e.__scopeSelect, children: /* @__PURE__ */ b("div", { children: e.children }) }) }),
        a
      ) : null;
    }
    return /* @__PURE__ */ b(Yr, { ...e, ref: t });
  }
);
jr.displayName = Ce;
var ee = 10, [Kr, ye] = _e(Ce), lc = "SelectContentImpl", uc = /* @__PURE__ */ We("SelectContent.RemoveScroll"), Yr = i.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      position: r = "item-aligned",
      onCloseAutoFocus: o,
      onEscapeKeyDown: a,
      onPointerDownOutside: c,
      //
      // PopperContent props
      side: s,
      sideOffset: u,
      align: l,
      alignOffset: f,
      arrowPadding: m,
      collisionBoundary: p,
      collisionPadding: h,
      sticky: w,
      hideWhenDetached: d,
      avoidCollisions: g,
      //
      ...y
    } = e, v = ve(Ce, n), [x, S] = i.useState(null), [E, A] = i.useState(null), C = j(t, (N) => S(N)), [P, k] = i.useState(null), [O, V] = i.useState(
      null
    ), B = wt(n), [L, T] = i.useState(!1), U = i.useRef(!1);
    i.useEffect(() => {
      if (x) return ys(x);
    }, [x]), Li();
    const M = i.useCallback(
      (N) => {
        const [W, ...K] = B().map((D) => D.ref.current), [H] = K.slice(-1), _ = document.activeElement;
        for (const D of N)
          if (D === _ || (D == null || D.scrollIntoView({ block: "nearest" }), D === W && E && (E.scrollTop = 0), D === H && E && (E.scrollTop = E.scrollHeight), D == null || D.focus(), document.activeElement !== _)) return;
      },
      [B, E]
    ), I = i.useCallback(
      () => M([P, x]),
      [M, P, x]
    );
    i.useEffect(() => {
      L && I();
    }, [L, I]);
    const { onOpenChange: R, triggerPointerDownPosRef: $ } = v;
    i.useEffect(() => {
      if (x) {
        let N = { x: 0, y: 0 };
        const W = (H) => {
          var _, D;
          N = {
            x: Math.abs(Math.round(H.pageX) - (((_ = $.current) == null ? void 0 : _.x) ?? 0)),
            y: Math.abs(Math.round(H.pageY) - (((D = $.current) == null ? void 0 : D.y) ?? 0))
          };
        }, K = (H) => {
          N.x <= 10 && N.y <= 10 ? H.preventDefault() : x.contains(H.target) || R(!1), document.removeEventListener("pointermove", W), $.current = null;
        };
        return $.current !== null && (document.addEventListener("pointermove", W), document.addEventListener("pointerup", K, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", W), document.removeEventListener("pointerup", K, { capture: !0 });
        };
      }
    }, [x, R, $]), i.useEffect(() => {
      const N = () => R(!1);
      return window.addEventListener("blur", N), window.addEventListener("resize", N), () => {
        window.removeEventListener("blur", N), window.removeEventListener("resize", N);
      };
    }, [R]);
    const [X, le] = mo((N) => {
      const W = B().filter((_) => !_.disabled), K = W.find((_) => _.ref.current === document.activeElement), H = po(W, N, K);
      H && setTimeout(() => H.ref.current.focus());
    }), De = i.useCallback(
      (N, W, K) => {
        const H = !U.current && !K;
        (v.value !== void 0 && v.value === W || H) && (k(N), H && (U.current = !0));
      },
      [v.value]
    ), Fe = i.useCallback(() => x == null ? void 0 : x.focus(), [x]), fe = i.useCallback(
      (N, W, K) => {
        const H = !U.current && !K;
        (v.value !== void 0 && v.value === W || H) && V(N);
      },
      [v.value]
    ), Re = r === "popper" ? Dt : Xr, we = Re === Dt ? {
      side: s,
      sideOffset: u,
      align: l,
      alignOffset: f,
      arrowPadding: m,
      collisionBoundary: p,
      collisionPadding: h,
      sticky: w,
      hideWhenDetached: d,
      avoidCollisions: g
    } : {};
    return /* @__PURE__ */ b(
      Kr,
      {
        scope: n,
        content: x,
        viewport: E,
        onViewportChange: A,
        itemRefCallback: De,
        selectedItem: P,
        onItemLeave: Fe,
        itemTextRefCallback: fe,
        focusSelectedItem: I,
        selectedItemText: O,
        position: r,
        isPositioned: L,
        searchRef: X,
        children: /* @__PURE__ */ b(Hr, { as: uc, allowPinchZoom: !0, children: /* @__PURE__ */ b(
          or,
          {
            asChild: !0,
            trapped: v.open,
            onMountAutoFocus: (N) => {
              N.preventDefault();
            },
            onUnmountAutoFocus: z(o, (N) => {
              var W;
              (W = v.trigger) == null || W.focus({ preventScroll: !0 }), N.preventDefault();
            }),
            children: /* @__PURE__ */ b(
              nr,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: a,
                onPointerDownOutside: c,
                onFocusOutside: (N) => N.preventDefault(),
                onDismiss: () => v.onOpenChange(!1),
                children: /* @__PURE__ */ b(
                  Re,
                  {
                    role: "listbox",
                    id: v.contentId,
                    "data-state": v.open ? "open" : "closed",
                    dir: v.dir,
                    onContextMenu: (N) => N.preventDefault(),
                    ...y,
                    ...we,
                    onPlaced: () => T(!0),
                    ref: C,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...y.style
                    },
                    onKeyDown: z(y.onKeyDown, (N) => {
                      const W = N.ctrlKey || N.altKey || N.metaKey;
                      if (N.key === "Tab" && N.preventDefault(), !W && N.key.length === 1 && le(N.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(N.key)) {
                        let H = B().filter((_) => !_.disabled).map((_) => _.ref.current);
                        if (["ArrowUp", "End"].includes(N.key) && (H = H.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(N.key)) {
                          const _ = N.target, D = H.indexOf(_);
                          H = H.slice(D + 1);
                        }
                        setTimeout(() => M(H)), N.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
Yr.displayName = lc;
var dc = "SelectItemAlignedPosition", Xr = i.forwardRef((e, t) => {
  const { __scopeSelect: n, onPlaced: r, ...o } = e, a = ve(Ce, n), c = ye(Ce, n), [s, u] = i.useState(null), [l, f] = i.useState(null), m = j(t, (C) => f(C)), p = wt(n), h = i.useRef(!1), w = i.useRef(!0), { viewport: d, selectedItem: g, selectedItemText: y, focusSelectedItem: v } = c, x = i.useCallback(() => {
    if (a.trigger && a.valueNode && s && l && d && g && y) {
      const C = a.trigger.getBoundingClientRect(), P = l.getBoundingClientRect(), k = a.valueNode.getBoundingClientRect(), O = y.getBoundingClientRect();
      if (a.dir !== "rtl") {
        const _ = O.left - P.left, D = k.left - _, q = C.left - D, re = C.width + q, He = Math.max(re, P.width), Ve = window.innerWidth - ee, Be = ln(D, [
          ee,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(ee, Ve - He)
        ]);
        s.style.minWidth = re + "px", s.style.left = Be + "px";
      } else {
        const _ = P.right - O.right, D = window.innerWidth - k.right - _, q = window.innerWidth - C.right - D, re = C.width + q, He = Math.max(re, P.width), Ve = window.innerWidth - ee, Be = ln(D, [
          ee,
          Math.max(ee, Ve - He)
        ]);
        s.style.minWidth = re + "px", s.style.right = Be + "px";
      }
      const V = p(), B = window.innerHeight - ee * 2, L = d.scrollHeight, T = window.getComputedStyle(l), U = parseInt(T.borderTopWidth, 10), M = parseInt(T.paddingTop, 10), I = parseInt(T.borderBottomWidth, 10), R = parseInt(T.paddingBottom, 10), $ = U + M + L + R + I, X = Math.min(g.offsetHeight * 5, $), le = window.getComputedStyle(d), De = parseInt(le.paddingTop, 10), Fe = parseInt(le.paddingBottom, 10), fe = C.top + C.height / 2 - ee, Re = B - fe, we = g.offsetHeight / 2, N = g.offsetTop + we, W = U + M + N, K = $ - W;
      if (W <= fe) {
        const _ = V.length > 0 && g === V[V.length - 1].ref.current;
        s.style.bottom = "0px";
        const D = l.clientHeight - d.offsetTop - d.offsetHeight, q = Math.max(
          Re,
          we + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (_ ? Fe : 0) + D + I
        ), re = W + q;
        s.style.height = re + "px";
      } else {
        const _ = V.length > 0 && g === V[0].ref.current;
        s.style.top = "0px";
        const q = Math.max(
          fe,
          U + d.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (_ ? De : 0) + we
        ) + K;
        s.style.height = q + "px", d.scrollTop = W - fe + d.offsetTop;
      }
      s.style.margin = `${ee}px 0`, s.style.minHeight = X + "px", s.style.maxHeight = B + "px", r == null || r(), requestAnimationFrame(() => h.current = !0);
    }
  }, [
    p,
    a.trigger,
    a.valueNode,
    s,
    l,
    d,
    g,
    y,
    a.dir,
    r
  ]);
  Y(() => x(), [x]);
  const [S, E] = i.useState();
  Y(() => {
    l && E(window.getComputedStyle(l).zIndex);
  }, [l]);
  const A = i.useCallback(
    (C) => {
      C && w.current === !0 && (x(), v == null || v(), w.current = !1);
    },
    [x, v]
  );
  return /* @__PURE__ */ b(
    mc,
    {
      scope: n,
      contentWrapper: s,
      shouldExpandOnScrollRef: h,
      onScrollButtonChange: A,
      children: /* @__PURE__ */ b(
        "div",
        {
          ref: u,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: S
          },
          children: /* @__PURE__ */ b(
            Z.div,
            {
              ...o,
              ref: m,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...o.style
              }
            }
          )
        }
      )
    }
  );
});
Xr.displayName = dc;
var fc = "SelectPopperPosition", Dt = i.forwardRef((e, t) => {
  const {
    __scopeSelect: n,
    align: r = "start",
    collisionPadding: o = ee,
    ...a
  } = e, c = bt(n);
  return /* @__PURE__ */ b(
    us,
    {
      ...c,
      ...a,
      ref: t,
      align: r,
      collisionPadding: o,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...a.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
Dt.displayName = fc;
var [mc, tn] = _e(Ce, {}), Ft = "SelectViewport", qr = i.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, nonce: r, ...o } = e, a = ye(Ft, n), c = tn(Ft, n), s = j(t, a.onViewportChange), u = i.useRef(0);
    return /* @__PURE__ */ J(st, { children: [
      /* @__PURE__ */ b(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: r
        }
      ),
      /* @__PURE__ */ b(yt.Slot, { scope: n, children: /* @__PURE__ */ b(
        Z.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...o,
          ref: s,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...o.style
          },
          onScroll: z(o.onScroll, (l) => {
            const f = l.currentTarget, { contentWrapper: m, shouldExpandOnScrollRef: p } = c;
            if (p != null && p.current && m) {
              const h = Math.abs(u.current - f.scrollTop);
              if (h > 0) {
                const w = window.innerHeight - ee * 2, d = parseFloat(m.style.minHeight), g = parseFloat(m.style.height), y = Math.max(d, g);
                if (y < w) {
                  const v = y + h, x = Math.min(w, v), S = v - x;
                  m.style.height = x + "px", m.style.bottom === "0px" && (f.scrollTop = S > 0 ? S : 0, m.style.justifyContent = "flex-end");
                }
              }
            }
            u.current = f.scrollTop;
          })
        }
      ) })
    ] });
  }
);
qr.displayName = Ft;
var Gr = "SelectGroup", [pc, hc] = _e(Gr), Qr = i.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, o = zt();
    return /* @__PURE__ */ b(pc, { scope: n, id: o, children: /* @__PURE__ */ b(Z.div, { role: "group", "aria-labelledby": o, ...r, ref: t }) });
  }
);
Qr.displayName = Gr;
var Jr = "SelectLabel", eo = i.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, o = hc(Jr, n);
    return /* @__PURE__ */ b(Z.div, { id: o.id, ...r, ref: t });
  }
);
eo.displayName = Jr;
var at = "SelectItem", [gc, to] = _e(at), no = i.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      value: r,
      disabled: o = !1,
      textValue: a,
      ...c
    } = e, s = ve(at, n), u = ye(at, n), l = s.value === r, [f, m] = i.useState(a ?? ""), [p, h] = i.useState(!1), w = j(
      t,
      (v) => {
        var x;
        return (x = u.itemRefCallback) == null ? void 0 : x.call(u, v, r, o);
      }
    ), d = zt(), g = i.useRef("touch"), y = () => {
      o || (s.onValueChange(r), s.onOpenChange(!1));
    };
    if (r === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ b(
      gc,
      {
        scope: n,
        value: r,
        disabled: o,
        textId: d,
        isSelected: l,
        onItemTextChange: i.useCallback((v) => {
          m((x) => x || ((v == null ? void 0 : v.textContent) ?? "").trim());
        }, []),
        children: /* @__PURE__ */ b(
          yt.ItemSlot,
          {
            scope: n,
            value: r,
            disabled: o,
            textValue: f,
            children: /* @__PURE__ */ b(
              Z.div,
              {
                role: "option",
                "aria-labelledby": d,
                "data-highlighted": p ? "" : void 0,
                "aria-selected": l && p,
                "data-state": l ? "checked" : "unchecked",
                "aria-disabled": o || void 0,
                "data-disabled": o ? "" : void 0,
                tabIndex: o ? void 0 : -1,
                ...c,
                ref: w,
                onFocus: z(c.onFocus, () => h(!0)),
                onBlur: z(c.onBlur, () => h(!1)),
                onClick: z(c.onClick, () => {
                  g.current !== "mouse" && y();
                }),
                onPointerUp: z(c.onPointerUp, () => {
                  g.current === "mouse" && y();
                }),
                onPointerDown: z(c.onPointerDown, (v) => {
                  g.current = v.pointerType;
                }),
                onPointerMove: z(c.onPointerMove, (v) => {
                  var x;
                  g.current = v.pointerType, o ? (x = u.onItemLeave) == null || x.call(u) : g.current === "mouse" && v.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: z(c.onPointerLeave, (v) => {
                  var x;
                  v.currentTarget === document.activeElement && ((x = u.onItemLeave) == null || x.call(u));
                }),
                onKeyDown: z(c.onKeyDown, (v) => {
                  var S;
                  ((S = u.searchRef) == null ? void 0 : S.current) !== "" && v.key === " " || (nc.includes(v.key) && y(), v.key === " " && v.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
no.displayName = at;
var $e = "SelectItemText", ro = i.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: o, ...a } = e, c = ve($e, n), s = ye($e, n), u = to($e, n), l = ac($e, n), [f, m] = i.useState(null), p = j(
      t,
      (y) => m(y),
      u.onItemTextChange,
      (y) => {
        var v;
        return (v = s.itemTextRefCallback) == null ? void 0 : v.call(s, y, u.value, u.disabled);
      }
    ), h = f == null ? void 0 : f.textContent, w = i.useMemo(
      () => /* @__PURE__ */ b("option", { value: u.value, disabled: u.disabled, children: h }, u.value),
      [u.disabled, u.value, h]
    ), { onNativeOptionAdd: d, onNativeOptionRemove: g } = l;
    return Y(() => (d(w), () => g(w)), [d, g, w]), /* @__PURE__ */ J(st, { children: [
      /* @__PURE__ */ b(Z.span, { id: u.textId, ...a, ref: p }),
      u.isSelected && c.valueNode && !c.valueNodeHasChildren ? ct.createPortal(a.children, c.valueNode) : null
    ] });
  }
);
ro.displayName = $e;
var oo = "SelectItemIndicator", io = i.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return to(oo, n).isSelected ? /* @__PURE__ */ b(Z.span, { "aria-hidden": !0, ...r, ref: t }) : null;
  }
);
io.displayName = oo;
var Ht = "SelectScrollUpButton", ao = i.forwardRef((e, t) => {
  const n = ye(Ht, e.__scopeSelect), r = tn(Ht, e.__scopeSelect), [o, a] = i.useState(!1), c = j(t, r.onScrollButtonChange);
  return Y(() => {
    if (n.viewport && n.isPositioned) {
      let s = function() {
        const l = u.scrollTop > 0;
        a(l);
      };
      const u = n.viewport;
      return s(), u.addEventListener("scroll", s), () => u.removeEventListener("scroll", s);
    }
  }, [n.viewport, n.isPositioned]), o ? /* @__PURE__ */ b(
    co,
    {
      ...e,
      ref: c,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: u } = n;
        s && u && (s.scrollTop = s.scrollTop - u.offsetHeight);
      }
    }
  ) : null;
});
ao.displayName = Ht;
var Vt = "SelectScrollDownButton", so = i.forwardRef((e, t) => {
  const n = ye(Vt, e.__scopeSelect), r = tn(Vt, e.__scopeSelect), [o, a] = i.useState(!1), c = j(t, r.onScrollButtonChange);
  return Y(() => {
    if (n.viewport && n.isPositioned) {
      let s = function() {
        const l = u.scrollHeight - u.clientHeight, f = Math.ceil(u.scrollTop) < l;
        a(f);
      };
      const u = n.viewport;
      return s(), u.addEventListener("scroll", s), () => u.removeEventListener("scroll", s);
    }
  }, [n.viewport, n.isPositioned]), o ? /* @__PURE__ */ b(
    co,
    {
      ...e,
      ref: c,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: u } = n;
        s && u && (s.scrollTop = s.scrollTop + u.offsetHeight);
      }
    }
  ) : null;
});
so.displayName = Vt;
var co = i.forwardRef((e, t) => {
  const { __scopeSelect: n, onAutoScroll: r, ...o } = e, a = ye("SelectScrollButton", n), c = i.useRef(null), s = wt(n), u = i.useCallback(() => {
    c.current !== null && (window.clearInterval(c.current), c.current = null);
  }, []);
  return i.useEffect(() => () => u(), [u]), Y(() => {
    var f;
    const l = s().find((m) => m.ref.current === document.activeElement);
    (f = l == null ? void 0 : l.ref.current) == null || f.scrollIntoView({ block: "nearest" });
  }, [s]), /* @__PURE__ */ b(
    Z.div,
    {
      "aria-hidden": !0,
      ...o,
      ref: t,
      style: { flexShrink: 0, ...o.style },
      onPointerDown: z(o.onPointerDown, () => {
        c.current === null && (c.current = window.setInterval(r, 50));
      }),
      onPointerMove: z(o.onPointerMove, () => {
        var l;
        (l = a.onItemLeave) == null || l.call(a), c.current === null && (c.current = window.setInterval(r, 50));
      }),
      onPointerLeave: z(o.onPointerLeave, () => {
        u();
      })
    }
  );
}), vc = "SelectSeparator", lo = i.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return /* @__PURE__ */ b(Z.div, { "aria-hidden": !0, ...r, ref: t });
  }
);
lo.displayName = vc;
var Bt = "SelectArrow", yc = i.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, o = bt(n), a = ve(Bt, n), c = ye(Bt, n);
    return a.open && c.position === "popper" ? /* @__PURE__ */ b(ds, { ...o, ...r, ref: t }) : null;
  }
);
yc.displayName = Bt;
var wc = "SelectBubbleInput", uo = i.forwardRef(
  ({ __scopeSelect: e, value: t, ...n }, r) => {
    const o = i.useRef(null), a = j(r, o), c = Vn(t);
    return i.useEffect(() => {
      const s = o.current;
      if (!s) return;
      const u = window.HTMLSelectElement.prototype, f = Object.getOwnPropertyDescriptor(
        u,
        "value"
      ).set;
      if (c !== t && f) {
        const m = new Event("change", { bubbles: !0 });
        f.call(s, t), s.dispatchEvent(m);
      }
    }, [c, t]), /* @__PURE__ */ b(
      Z.select,
      {
        ...n,
        style: { ...Mr, ...n.style },
        ref: a,
        defaultValue: t
      }
    );
  }
);
uo.displayName = wc;
function fo(e) {
  return e === "" || e === void 0;
}
function mo(e) {
  const t = xe(e), n = i.useRef(""), r = i.useRef(0), o = i.useCallback(
    (c) => {
      const s = n.current + c;
      t(s), function u(l) {
        n.current = l, window.clearTimeout(r.current), l !== "" && (r.current = window.setTimeout(() => u(""), 1e3));
      }(s);
    },
    [t]
  ), a = i.useCallback(() => {
    n.current = "", window.clearTimeout(r.current);
  }, []);
  return i.useEffect(() => () => window.clearTimeout(r.current), []), [n, o, a];
}
function po(e, t, n) {
  const o = t.length > 1 && Array.from(t).every((l) => l === t[0]) ? t[0] : t, a = n ? e.indexOf(n) : -1;
  let c = bc(e, Math.max(a, 0));
  o.length === 1 && (c = c.filter((l) => l !== n));
  const u = c.find(
    (l) => l.textValue.toLowerCase().startsWith(o.toLowerCase())
  );
  return u !== n ? u : void 0;
}
function bc(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var xc = Vr, ho = $r, Sc = Zr, Ec = Ur, go = zr, nn = jr, vo = qr, Cc = Qr, yo = eo, rn = no, wo = ro, bo = io, xo = ao, So = so, Eo = lo;
const Ac = lt(
  "ui-flex ui-w-full ui-items-center ui-justify-between ui-rounded-md ui-border ui-border-gray-200 ui-bg-background ui-px-3 ui-py-2 ui-text-sm ui-ring-offset-background placeholder:ui-text-muted-foreground focus:ui-outline-none focus:ui-ring-1 focus:ui-ring-ring focus:ui-ring-offset-1 disabled:ui-cursor-not-allowed disabled:ui-opacity-50 [&>span]:ui-line-clamp-1",
  {
    variants: {
      size: {
        sm: "ui-h-8 ui-text-xs",
        md: "ui-h-10 ui-text-sm",
        lg: "ui-h-12 ui-text-lg"
      }
    },
    defaultVariants: {
      size: "md"
    }
  }
), zc = xc, jc = Cc, Kc = Sc, Rc = ({
  ref: e,
  className: t,
  children: n,
  size: r,
  ...o
}) => /* @__PURE__ */ J(
  ho,
  {
    ref: e,
    className: F(Ac({ size: r }), t),
    ...o,
    children: [
      n,
      /* @__PURE__ */ b(Ec, { asChild: !0, children: /* @__PURE__ */ b(Xn, { className: "ui-h-4 ui-w-4 ui-opacity-50" }) })
    ]
  }
);
Rc.displayName = ho.displayName;
const Co = ({
  ref: e,
  className: t,
  ...n
}) => /* @__PURE__ */ b(
  xo,
  {
    ref: e,
    className: F(
      "ui-flex ui-cursor-default ui-items-center ui-justify-center ui-py-1",
      t
    ),
    ...n,
    children: /* @__PURE__ */ b(vi, { className: "ui-h-4 ui-w-4" })
  }
);
Co.displayName = xo.displayName;
const Ao = ({
  ref: e,
  className: t,
  ...n
}) => /* @__PURE__ */ b(
  So,
  {
    ref: e,
    className: F(
      "ui-flex ui-cursor-default ui-items-center ui-justify-center ui-py-1",
      t
    ),
    ...n,
    children: /* @__PURE__ */ b(Xn, { className: "ui-h-4 ui-w-4" })
  }
);
Ao.displayName = So.displayName;
const Nc = ({
  ref: e,
  className: t,
  children: n,
  position: r = "popper",
  ...o
}) => /* @__PURE__ */ b(go, { children: /* @__PURE__ */ J(
  nn,
  {
    ref: e,
    className: F(
      "ui-relative ui-z-50 ui-max-h-56 ui-min-w-[8rem] ui-overflow-hidden ui-rounded-md ui-border ui-bg-popover ui-text-popover-foreground ui-shadow-loose data-[state=open]:ui-animate-in data-[state=closed]:ui-animate-out data-[state=closed]:ui-fade-out-0 data-[state=open]:ui-fade-in-0 data-[state=closed]:ui-zoom-out-95 data-[state=open]:ui-zoom-in-95 data-[side=bottom]:ui-slide-in-from-top-2 data-[side=left]:ui-slide-in-from-right-2 data-[side=right]:ui-slide-in-from-left-2 data-[side=top]:ui-slide-in-from-bottom-2",
      r === "popper" && "data-[side=bottom]:ui-translate-y-1 data-[side=left]:ui--translate-x-1 data-[side=right]:ui-translate-x-1 data-[side=top]:ui--translate-y-1",
      t
    ),
    position: r,
    ...o,
    children: [
      /* @__PURE__ */ b(Co, { ref: e }),
      /* @__PURE__ */ b(
        vo,
        {
          className: F(
            "ui-p-1",
            r === "popper" && "ui-h-[var(--radix-select-trigger-height)] ui-w-full ui-min-w-[var(--radix-select-trigger-width)]"
          ),
          children: n
        }
      ),
      /* @__PURE__ */ b(Ao, { ref: e })
    ]
  }
) });
Nc.displayName = nn.displayName;
const Pc = ({
  ref: e,
  className: t,
  ...n
}) => /* @__PURE__ */ b(
  yo,
  {
    ref: e,
    className: F("ui-py-1.5 ui-px-8 ui-text-sm ui-font-semibold", t),
    ...n
  }
);
Pc.displayName = yo.displayName;
const Ro = "ui-relative ui-min-h-12 ui-flex ui-w-full ui-cursor-default ui-select-none hover:ui-bg-blue-50 ui-items-center ui-rounded-sm ui-py-1.5 ui-px-8 ui-text-sm ui-outline-none focus:ui-bg-blue-50 focus:ui-text-accent-foreground data-[disabled]:ui-pointer-events-none data-[disabled]:ui-opacity-50", No = "ui-absolute ui-left-2 ui-flex ui-h-3.5 ui-w-3.5 ui-items-center ui-justify-center", Mc = ({
  ref: e,
  className: t,
  children: n,
  ...r
}) => /* @__PURE__ */ J(
  rn,
  {
    ref: e,
    className: F(Ro, t),
    ...r,
    children: [
      /* @__PURE__ */ b("span", { className: No, children: /* @__PURE__ */ b(bo, { children: /* @__PURE__ */ b(Ut, { className: "ui-h-4 ui-w-4" }) }) }),
      /* @__PURE__ */ b(wo, { children: n })
    ]
  }
), Yc = ({
  ref: e,
  className: t,
  children: n,
  icon: r,
  iconPosition: o,
  ...a
}) => /* @__PURE__ */ J(
  rn,
  {
    ref: e,
    className: F(Ro, t),
    ...a,
    children: [
      /* @__PURE__ */ b("span", { className: No, children: /* @__PURE__ */ b(bo, { children: /* @__PURE__ */ b(Ut, { className: "ui-h-4 ui-w-4" }) }) }),
      /* @__PURE__ */ J("div", { className: "ui-flex ui-items-center ui-gap-2 ui-w-full", children: [
        o === "left" && r,
        /* @__PURE__ */ b(wo, { asChild: !0, className: "ui-w-full", children: /* @__PURE__ */ b("div", { className: "ui-w-full", children: n }) }),
        o === "right" && r
      ] })
    ]
  }
);
Mc.displayName = rn.displayName;
const Tc = ({
  ref: e,
  className: t,
  children: n,
  position: r = "popper",
  ...o
}) => /* @__PURE__ */ b(go, { children: /* @__PURE__ */ b(
  nn,
  {
    ref: e,
    className: F(
      "ui-relative ui-z-50 ui-p-8 gap-3 ui-max-h-56 ui-min-w-[8rem] ui-overflow-hidden ui-rounded-md ui-border ui-bg-popover ui-text-popover-foreground ui-shadow-loose data-[state=open]:ui-animate-in data-[state=closed]:ui-animate-out data-[state=closed]:ui-fade-out-0 data-[state=open]:ui-fade-in-0 data-[state=closed]:ui-zoom-out-95 data-[state=open]:ui-zoom-in-95 data-[side=bottom]:ui-slide-in-from-top-2 data-[side=left]:ui-slide-in-from-right-2 data-[side=right]:ui-slide-in-from-left-2 data-[side=top]:ui-slide-in-from-bottom-2",
      r === "popper" && "data-[side=bottom]:ui-translate-y-1 data-[side=left]:ui--translate-x-1 data-[side=right]:ui-translate-x-1 data-[side=top]:ui--translate-y-1",
      t
    ),
    position: r,
    ...o,
    children: /* @__PURE__ */ b(
      vo,
      {
        className: F(
          "ui-p-1",
          r === "popper" && "ui-h-[var(--radix-select-trigger-height)] ui-w-full ui-min-w-[var(--radix-select-trigger-width)]"
        ),
        children: n
      }
    )
  }
) });
Tc.displayName = "EmptySelectContent";
const Oc = ({
  ref: e,
  className: t,
  ...n
}) => /* @__PURE__ */ b(
  Eo,
  {
    ref: e,
    className: F("ui-mx-1 ui-my-1 ui-h-px ui-bg-muted", t),
    ...n
  }
);
Oc.displayName = Eo.displayName;
const Ic = lt(
  "ui-relative ui-w-full ui-rounded-lg ui-border-none ui-p-4 [&>svg~*]:ui-pl-7 [&>svg+div]:ui-translate-y-[-3px] [&>svg]:ui-absolute [&>svg]:ui-left-4 [&>svg]:ui-top-1/2 [&>svg]:ui-translate-y-[-50%]",
  {
    variants: {
      variant: {
        default: "ui-bg-background ui-text-foreground",
        info: "ui-bg-blue-50 ui-text-blue-600",
        success: "ui-bg-green-50 ui-text-green-800",
        warning: "ui-bg-yellow-50 ui-text-yellow-600",
        error: "ui-bg-red-50 ui-text-red-600",
        destructive: "ui-border-destructive/50 ui-text-destructive dark:ui-border-destructive [&>svg]:ui-text-destructive"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), kc = ({
  ref: e,
  className: t,
  variant: n,
  ...r
}) => /* @__PURE__ */ b(
  "div",
  {
    ref: e,
    role: "alert",
    className: F(Ic({ variant: n, className: t })),
    ...r
  }
);
kc.displayName = "Alert";
const Lc = ({
  ref: e,
  className: t,
  children: n,
  ...r
}) => /* @__PURE__ */ b(
  "h5",
  {
    ref: e,
    className: F(
      "ui-font-medium ui-text-sm ui-ml-2 ui-leading-none ui-tracking-tight",
      t
    ),
    ...r,
    children: n
  }
);
Lc.displayName = "AlertTitle";
const _c = ({
  ref: e,
  className: t,
  ...n
}) => /* @__PURE__ */ b(
  "div",
  {
    ref: e,
    className: F(
      "ui-text-xs ui-ml-2 ui-mt-1 [&_p]:ui-leading-relaxed",
      t
    ),
    ...n
  }
);
_c.displayName = "AlertDescription";
export {
  kc as Alert,
  _c as AlertDescription,
  Lc as AlertTitle,
  Wo as Button,
  xi as Checkbox,
  Tc as EmptySelectContent,
  $c as Form,
  qo as FormControl,
  Go as FormDescription,
  Wc as FormField,
  Yo as FormItem,
  Xo as FormLabel,
  Qo as FormMessage,
  Zo as Input,
  Dn as Label,
  Si as MultiStateCheckbox,
  zc as Select,
  Nc as SelectContent,
  jc as SelectGroup,
  Mc as SelectItem,
  Yc as SelectItemWithIcon,
  Pc as SelectLabel,
  Ao as SelectScrollDownButton,
  Co as SelectScrollUpButton,
  Oc as SelectSeparator,
  Rc as SelectTrigger,
  Kc as SelectValue,
  $o as buttonVariants,
  Ac as selectVariants,
  ut as useFormField
};
